<template>
  <div class="row">

    <div class="col-lg-12">
      <div class="row">
        <base-button :style="{ color: colors.primary }" style="font-size: 18px" v-on:click="modals.cancelModal = true"
          class="btn-link">
          &lt; Back
        </base-button>
      </div>

      <div v-if="module == 'vendor'">
        <div id="app">
          <div class="tabs" v-if="view !== 'add'">
            <div class="tab-container" style="display: flex; align-items: center;">
              <!-- Scrollable Tab List -->
              <div class="tab-list"
                style="display: inline-flex; overflow-x: auto; flex-grow: 1; padding-right: 10px; border-bottom: 1px solid #ccc;">
                <div v-for="(tab, index) in tabs" :key="index" :class="{
          'first-tabb': index === 0,
          'other-tabb': index !== 0 && index !== 5,
          'last-tabb': index === 5,
          'inactive-tabb': activeTab !== index,
        }" @click="activeTab = index" style="flex-shrink: 0;">
                  <p :class="{
          'active-tabb-title': activeTab === index,
          'inactive-tabb-title': activeTab !== index,
        }">
                    {{ tab.name }}
                  </p>
                </div>

              </div>
              <div class="col-lg-1 d-flex justify-content-center align-items-center" style="flex-shrink: 0;">
                <base-button class="btn-icon-eprf btn-icon btn-round" title="Add a new transporter"
                  @click="modals.addTransporter = true">
                  <i class="tim-icons icon-simple-add"></i>
                </base-button>
              </div>
            </div>

            <br />

            <div class="tab-content">
              <div v-for="(tab, index) in tabs" :key="index" v-show="activeTab === index">
                <div v-if="tab.name == 'Details'" class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-12">
                      <div>
                        <div class="row" v-if="module == 'vendor'">
                          <div class="col-lg-6 d-flex" v-if="module != 'authority'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    BASIC DETAILS
                                  </p>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-lg-6">
                                  <p style="color: #A5A5A5">
                                    Company Name <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="companyname" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Company Reg. No. <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="companyregno" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Company Address <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="companyaddress" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">Company Fax Number</p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="companyfaxno" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Company Phone Number <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="companyphonenumber" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                    <p v-if="iscompanyphonenumber" style="font-size: 12px; color: #EC1B23">
                                      The length of the phone number is insufficient.
                                    </p>
                                  </div>
                                </div>
                                <div class="col-lg-6">
                                  <p style="color: #A5A5A5" v-if="module == 'vendor'">
                                    DOE License No. <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px" v-if="module == 'vendor'">
                                    <input type="text" v-model="doelicense" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5" v-if="module == 'vendor'">
                                    DOE License Expiry <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px" v-if="module == 'vendor'">
                                    <el-date-picker v-model="doeexpired" placeholder="Select"
                                      :disabled="preview"></el-date-picker>
                                  </div>

                                  <p style="color: #A5A5A5" v-if="module == 'vendor'">
                                    Facility Type <span style="color: #EC1B23">*</span>
                                  </p>
                                  <el-select v-if="module == 'vendor'" class="select-info tab select-width"
                                    placeholder="Select" v-model="selects.facility"
                                    style="width: 90%; border-bottom: 1px solid lightgray" filterable
                                    :disabled="preview">
                                    <el-option v-for="re in selects.facilitytypes" class="select-info custom-option"
                                      :value="re.value" :label="re.label" :key="re.value"></el-option>
                                  </el-select>

                                  <p style="color: #A5A5A5" v-if="module == 'land' || module == 'vessel'">
                                    Position <span style="color: #EC1B23">*</span>
                                  </p>
                                  <el-select v-if="module == 'land' || module == 'vessel'"
                                    class="select-info tab select-width" placeholder="Select" v-model="position"
                                    style="width: 90%; border-bottom: 1px solid lightgray" filterable
                                    :disabled="preview">
                                    <el-option v-for="re in selects.positions" class="select-info" :value="re.value"
                                      :label="re.label" :key="re.value"></el-option>
                                  </el-select>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-3 d-flex" v-if="module == 'authority'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    BASIC DETAILS
                                  </p>
                                </div>
                              </div>
                              <div class="row" style="height: 520px">
                                <div class="col-lg">
                                  <p style="color: #A5A5A5">
                                    Agency Name <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="agencyname" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Phone Number <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="phonenumber" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                    <p v-if="isphonenumber" style="font-size: 12px; color: #EC1B23">
                                      The length of the phone number is insufficient.
                                    </p>
                                  </div>

                                  <p style="color: #A5A5A5">Fax Number</p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="faxnumber" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-6 d-flex" v-if="module == 'vendor'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    SW CODES
                                  </p>
                                </div>
                              </div>
                              <div v-if="update" class="row">
                                <div class="col-lg">
                                  <el-select v-if="module == 'vendor'" class="select-info tab select-width"
                                    placeholder="Select" v-model="selects.sw" @change="addWasteHandle()" style="
                    width: 90%;
                    border-bottom: 1px solid lightgray;
                    color: pink !important;
                  " filterable :disabled="preview">
                                    <el-option v-for="re in selects.swes" class="select-info" :value="re.value"
                                      :label="re.label" :key="re.value"></el-option>
                                  </el-select>
                                </div>
                              </div>
                              <br />
                              <div class="col-lg-12"
                                :style="{ height: !update ? '371px' : '330px', overflowY: 'auto' }">
                                <div v-if="update" class="row">
                                  <div class="col-lg-4 text-center">
                                    <p style="color: #707070;">CODE</p>
                                  </div>
                                  <div class="col-lg-3 text-center">
                                    <p style="color: #707070;">BUY PRICE (RM/Kg)</p>
                                  </div>
                                  <div class="col-lg-3 text-center">
                                    <p style="color: #707070;">SELL PRICE (RM/Kg)</p>
                                  </div>
                                  <div class="col-lg-2 text-center">
                                    <p style="color: #707070;"></p>
                                  </div>
                                </div>

                                <div v-if="!update" class="row">
                                  <div class="col-lg-4 text-center">
                                    <p style="color: #707070;">CODE</p>
                                  </div>
                                  <div class="col-lg-4 text-right">
                                    <p style="color: #707070;">BUY PRICE (RM/Kg)</p>
                                  </div>
                                  <div class="col-lg-4 text-right">
                                    <p style="color: #707070;">SELL PRICE (RM/Kg)</p>
                                  </div>
                                </div>


                                <div v-if="update" class="row" v-for="(item, index) in wastehandle"
                                  :key="'waste_handle_item_' + index">
                                  <div class="col-lg-4 text-center">
                                    <p class="newtitle"
                                      style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ item.waste_type_name }}
                                    </p>
                                  </div>
                                  <div class="col-lg-3">
                                    <div>
                                      <input type="number" v-model="item.buy_price" :class="{ 'custom-input': true }"
                                        min="0" :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-3">
                                    <div>
                                      <input type="number" v-model="item.sell_price" :class="{ 'custom-input': true }"
                                        min="0" :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-2 text-center">
                                    <base-button class="btn-cancel btn-icon btn-round"
                                      @click="wastehandle.splice(item.id, 1)"><i
                                        class="tim-icons icon-simple-remove"></i></base-button>
                                  </div>
                                </div>

                                <div v-if="!update && wastehandle.length != 0" class="row"
                                  v-for="(item, index) in wastehandle" :key="'update_waste_handle_item_' + index">
                                  <div class="col-lg-4 text-center">
                                    <p class="newtitle"
                                      style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ item.waste_type_name }}
                                    </p>
                                  </div>
                                  <div class="col-lg-4 text-center">
                                    <p class="newtitle" style="text-align: right">
                                      {{ item.buy_price }}
                                    </p>
                                  </div>
                                  <div class="col-lg-4 text-center">
                                    <p class="newtitle" style="text-align: right">
                                      {{ item.sell_price }}
                                    </p>
                                  </div>
                                </div>

                                <div v-if="!update && wastehandle.length === 0" class="row">
                                  <div class="col-lg-11 text-center">
                                    <p class="newtitle"
                                      style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      No data
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <br />
                              <div class="row">
                                <div class="col-lg"></div>
                                <div v-if="update" class="col-lg-6 text-right">
                                  <base-button v-if="preview == false" :disabled="buttondisabled" type="primary"
                                    @click="updateWasteHandle">Update
                                  </base-button>
                                </div>
                                <div v-if="!update" class="col-lg-6 text-right">
                                  <base-button v-if="preview == false" :disabled="buttondisabled" type="primary"
                                    @click="update = !update">Edit
                                  </base-button>
                                </div>
                              </div>
                            </card>
                          </div>
                          <!-- <div v-for="(transporter, index) in transporterdetails" :key="'vendor_transporter' + index"
                          class="col-lg-3 d-flex" v-if="module == 'vendor'">
                          <card class="card-eprf">
                            <br />
                            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                              TRANSPORTER DETAILS - {{ index + 1 }}
                            </p>
                            <div class="row">
                              <div class="col-lg">
                                <p style="color: #A5A5A5">
                                  Transporter Name <span style="color: #EC1B23">*</span>
                                </p>
                                <div style="padding-right: 30px">
                                  <input type="text" v-model="transporter.name" :class="{ 'custom-input': true }"
                                    :disabled="preview" />
                                </div>

                                <p style="color: #A5A5A5">
                                  DOE No <span style="color: #EC1B23">*</span>
                                </p>
                                <div style="padding-right: 30px">
                                  <input type="text" v-model="transporter.doeno" :class="{ 'custom-input': true }"
                                    :disabled="preview" />
                                </div>

                                <p style="color: #A5A5A5">
                                  Transporter Address <span style="color: #EC1B23">*</span>
                                </p>
                                <div style="padding-right: 30px">
                                  <input type="text" v-model="transporter.address" :class="{ 'custom-input': true }"
                                    :disabled="preview" />
                                </div>

                                <p style="color: #A5A5A5">
                                  Transporter Phone No. <span style="color: #EC1B23">*</span>
                                </p>
                                <div style="padding-right: 30px">
                                  <input type="text" v-model="transporter.phoneno" :class="{ 'custom-input': true }"
                                    :disabled="preview" />
                                  <p v-if="istransporterphoneno" style="font-size: 12px; color: #EC1B23">
                                    The length of the phone number is insufficient.
                                  </p>
                                </div>

                                <p style="color: #A5A5A5">Transporter Fax</p>
                                <div style="padding-right: 30px">
                                  <input type="text" v-model="transporter.fax" :class="{ 'custom-input': true }"
                                    :disabled="preview" />
                                </div>

                                <br /><br /><br />
                                <div class="row">
                                  <div class="col-lg"></div>
                                  <div class="col-lg-6 text-right">
                                    <base-button type="primary" @click="saveTransporter(transporterdetails, index)">Save
                                    </base-button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </card>
                        </div> -->
                          <div class="col-lg-3 d-flex" v-if="module == 'vessel'" v-for="(item, index) in ships"
                            :key="'vessel_ship_detail_' + index">
                            <card class="card-eprf">
                              <br />
                              <div class="row">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    SHIP DETAILS
                                  </p>
                                </div>
                                <div class="col-lg-2 text-right">
                                  <base-button class="btn-icon btn-round btn-cancel" @click="removeship(index)"><i
                                      class="tim-icons icon-simple-remove"></i>
                                  </base-button>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-lg">
                                  <p style="color: #A5A5A5">
                                    Ship Name <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.shipname" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Ship Type <span style="color: #EC1B23">*</span>
                                  </p>
                                  <el-select class="select-info tab select-width" placeholder="Select"
                                    v-model="item.shiptype" style="width: 90%; border-bottom: 1px solid lightgray"
                                    :disabled="preview" filterable>
                                    <el-option v-for="option in selects.shiptypes" class="select-info"
                                      :value="option.value" :label="option.label" :key="option.value"></el-option>
                                  </el-select>

                                  <p style="color: #A5A5A5">
                                    IMO Number <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.imonumber" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Gross Tonnage <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="number" v-model="item.grosstonnage" :class="{ 'custom-input': true }"
                                      min="0" :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Deadweight Tonnage <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="number" v-model="item.deadweighttonnage"
                                      :class="{ 'custom-input': true }" min="0" :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Operator Name <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.operatorname" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Call Sign <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.callsign" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Flag <span style="color: #EC1B23">*</span>
                                  </p>
                                  <el-select class="select-info tab select-width" placeholder="Select"
                                    v-model="item.flag" style="width: 90%; border-bottom: 1px solid lightgray"
                                    filterable :disabled="preview">
                                    <el-option v-for="option in selects.flags" class="select-info" :value="option.value"
                                      :label="option.label" :key="option.value"></el-option>
                                  </el-select>
                                </div>
                              </div>
                            </card>
                          </div>
                          <!-- add ships -->
                          <div class="col-lg-3 d-flex" v-if="module == 'vessel'">
                            <card class="card-eprf">
                              <br />
                              <div class="row">
                                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                  ADD SHIP
                                </p>
                              </div>
                              <br />
                              <br />
                              <div class="row">
                                <div class="col-lg text-center">
                                  <base-button class="btn-icon-eprf btn-link" @click="addship()"
                                    :disabled="preview"><img src="@/assets/img/plus.png" width="230" />
                                  </base-button>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-3 d-flex" v-if="view !== 'add' && module == 'authority'">
                            <card class="card-eprf">
                              <br />

                              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                UPLOAD AUTHORITY SUPPORT DOCUMENT
                              </p>
                              <p class="newtitle">Choose File from Your Desktop</p>
                              <!-- <p class="sub-title">
              Please upload any existing contract for recurring job request
            </p> -->
                              <div class="fileinput">
                                <label for="authority-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                                  Choose File
                                </label>
                                <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
                                <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                                  <circle-8></circle-8>
                                </div>

                                <input accept="application/pdf" id="authority-upload" type="file" ref="authorityfile"
                                  name="..." class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                  v-on:change="onInvoiceChange5" :disabled="preview" />
                              </div>
                              <div v-if="uploadload == false" style="
                height: 200px;;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                <div v-for="(file, index) in allauthority" :key="'file_allauthority_' + index"
                                  class="row">
                                  <div class="col-lg-8">
                                    <a :href="file.fileurl">
                                      <base-button class="btn-link btn-primary">
                                        {{ file.filename }}
                                      </base-button>
                                    </a>
                                  </div>
                                  <div class="col-lg-4">
                                    <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                      @click="removeAuthorityFile(file.fileid)" :disabled="preview">
                                      Remove
                                    </base-button>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-3 d-flex">
                            <card class="card-eprf">
                              <br />

                              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                UPLOAD COMPANY SUPPORT DOCUMENT
                              </p>
                              <p class="newtitle">Choose File from Your Desktop</p>
                              <p class="sub-title">
                                Please upload any existing contract for recurring job request
                              </p>
                              <div class="fileinput">
                                <label for="invoice-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                                  Choose File
                                </label>
                                <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
                                <div class="d-flex justify-content-center spinner" v-if="compsupdoc == true">
                                  <circle-8></circle-8>
                                </div>

                                <input accept="application/pdf" id="invoice-upload" type="file" ref="invoicefile"
                                  name="..." class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                  v-on:change="onFileChangeCompanySupportDoc" :disabled="preview" />
                              </div>
                              <div v-if="compsupdoc == false" style="
                height: 200px;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                <div v-for="(file, index) in allInvoice" :key="'file_allinvoice_' + index" class="row">
                                  <div class="col-lg-8">
                                    <a :href="file.fileurl">
                                      <base-button class="btn-link btn-primary">
                                        {{ file.filename }}
                                      </base-button>
                                    </a>
                                  </div>
                                  <div class="col-lg-4">
                                    <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                      @click="removecompanyfile(file.fileid)" :disabled="preview">
                                      Remove
                                    </base-button>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-3 d-flex">
                            <card class="card-eprf">
                              <br />

                              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                UPLOAD DOE SUPPORT DOCUMENT
                              </p>
                              <p class="newtitle">Choose File from Your Desktop</p>
                              <p class="sub-title">
                                Please upload any existing contract for recurring job request
                              </p>
                              <div class="fileinput">
                                <label for="doe-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                                  Choose File
                                </label>
                                <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
                                <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                                  <circle-8></circle-8>
                                </div>

                                <input accept="application/pdf" id="doe-upload" type="file" ref="doefile" name="..."
                                  class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                  v-on:change="onFileChangeDoeDoc" :disabled="preview" />
                              </div>
                              <div v-if="uploadload == false" style="
                height: 200px;;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                <div v-for="(file, index) in alldoe" :key="'file_alldoe_' + index" class="row">
                                  <div class="col-lg-8">
                                    <a :href="file.fileurl">
                                      <base-button class="btn-link btn-primary">
                                        {{ file.filename }}
                                      </base-button>
                                    </a>
                                  </div>
                                  <div class="col-lg-4">
                                    <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                      @click="removeDoeDoc(file.fileid)" :disabled="preview">
                                      Remove
                                    </base-button>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-3 d-flex" v-if="view !== 'add' && module == 'vessel'">
                            <card class="card-eprf">
                              <br />

                              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                UPLOAD SHIP SUPPORT DOCUMENT
                              </p>
                              <p class="newtitle">Choose File from Your Desktop</p>
                              <p class="sub-title">
                                Please upload any existing contract for recurring job request
                              </p>
                              <div class="fileinput">
                                <label for="ship-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                                  Choose File
                                </label>
                                <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
                                <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                                  <circle-8></circle-8>
                                </div>

                                <input accept="application/pdf" id="ship-upload" type="file" ref="shipfile" name="..."
                                  class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                  v-on:change="onInvoiceChange2" :disabled="preview" />
                              </div>
                              <div v-if="uploadload == false" style="
                height: 200px;;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                <div v-for="(file, index) in allships" :key="'file_allships_' + index" class="row">
                                  <div class="col-lg-8">
                                    <a :href="file.fileurl">
                                      <base-button class="btn-link btn-primary">
                                        {{ file.filename }}
                                      </base-button>
                                    </a>
                                  </div>
                                  <div class="col-lg-4">
                                    <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                      @click="removeShipFile(file.fileid)" :disabled="preview">
                                      Remove
                                    </base-button>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>

                          <!-- <div class="col-lg-3 d-flex">
                            <card class="card-eprf">
                              <br />
                              <div class="row">
                                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                  ADD PIC
                                </p>
                              </div>
                              <br />
                              <br />
                              <div class="row">
                                <div class="col-lg text-center">
                                  <base-button class="btn-icon-eprf btn-link" @click="addpic()" :disabled="preview"><img
                                      src="@/assets/img/plus.png" width="230" />
                                  </base-button>
                                </div>
                              </div>
                            </card>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else-if="tab.name == 'PIC'" class="full-size-container">
                  <div class="row">
                    <div class="col-lg-12" v-if="view !== 'add' && module == 'vendor'">
                      <card class="card-eprf">
                        <br />
                        <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                          PIC DETAILS
                        </p>
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-lg-9"></div>
                            <div class="col-lg-3 text-right">
                              <base-button title="Add a new PIC" type="primary" v-on:click="modals.addPIC = true">Add
                                PIC
                              </base-button>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12 text-center">
                          <el-table :data="picdetails" style="width: 100%" height="700" :header-cell-style="{
          background: 'transparent',
          color: 'gray',
        }" class="custom-table">
                            <el-table-column :min-width="50" align="center" label="No">
                              <div slot-scope="scope">
                                {{ scope.$index + 1 }}
                              </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="center" label="Username"
                              prop="username"></el-table-column>
                            <el-table-column :min-width="200" align="center" label="Useremail"
                              prop="useremail"></el-table-column>
                            <el-table-column :min-width="200" align="center" label="Phone Number"
                              prop="userphonenumber"></el-table-column>
                            <el-table-column :min-width="200" align="center" label="Fax Number"
                              prop="userfaxnumber"></el-table-column>
                            <el-table-column :min-width="80" align="center">
                              <div slot-scope="scope">
                                <i style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: #A5A5A5;
                    font-size: 15px;
                    font-weight: 900;
                    cursor: pointer;
                  " @click="editpic(scope.$index, scope.row.username, scope.row.useremail, scope.row.userphonenumber, scope.row.userfaxnumber,)"
                                  class="tim-icons icon-pencil"></i>
                              </div>
                            </el-table-column>
                            <el-table-column :min-width="80" align="center">
                              <div slot-scope="scope">
                                <i style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: #EC1B23;
                    font-size: 15px;
                    font-weight: 900;
                    cursor: pointer;
                  " @click="removepicc(scope.$index)" class="tim-icons icon-trash-simple"></i>
                              </div>
                            </el-table-column>
                          </el-table>
                        </div>
                      </card>
                    </div>
                  </div>
                </div>

                <div v-else class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-12">
                      <div>
                        <div class="row" v-if="module == 'vendor'">
                          <div class="col-lg-6 d-flex" v-if="module != 'authority'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    TRANSPORTER DETAILS - {{ index }}

                                  </p>
                                </div>
                                <div class="col-lg-2 text-right">
                                  <base-button class="btn-icon btn-round btn-cancel"
                                    @click="deletetransporter(tab.transporter_id)"><i
                                      class="tim-icons icon-simple-remove"></i>
                                  </base-button>
                                </div>
                              </div>
                              <div class="col-lg-12">

                                <div class="row">
                                  <div class="col-lg-12">

                                    <p style="color: #A5A5A5">
                                      Transporter Name <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="tab.transporter_name"
                                        :class="{ 'custom-input': true }" :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-12">

                                    <p style="color: #A5A5A5">
                                      DOE No <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="tab.doe_no" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-12">

                                    <p style="color: #A5A5A5">
                                      Transporter Address <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="tab.transporter_address"
                                        :class="{ 'custom-input': true }" :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-12">

                                    <p style="color: #A5A5A5">
                                      Transporter Phone No. <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="tab.transporter_phone"
                                        :class="{ 'custom-input': true }" :disabled="preview" />
                                      <p v-if="istransporterphoneno" style="font-size: 12px; color: #EC1B23">
                                        The length of the phone number is insufficient.
                                      </p>
                                    </div>
                                  </div>
                                  <div class="col-lg-12">

                                    <p style="color: #A5A5A5">Transporter Fax</p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="tab.transporter_fax" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>
                                  </div>

                                  <br /><br /><br />
                                  <div class="row">
                                    <div class="col-lg"></div>
                                    <div class="col-lg-6 text-right">
                                      <!-- <base-button type="primary" @click="saveTransporter(transporterdetails, index)">Save -->
                                      <!-- </base-button> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-6 d-flex" v-if="module == 'vendor'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    UPLOAD TRANSPORTER SUPPORT DOCUMENT - {{ index }}

                                  </p>
                                </div>
                              </div>
                              <div class="col-lg-12"
                                :style="{ height: !update ? '371px' : '330px', overflowY: 'auto' }">
                                <div :key="'doc' + index" class="fileinput">
                                  <!-- The label is connected to the input with a dynamic id based on index -->
                                  <label :for="tab.transporter_id" type="primary" class="btn" style="
font-size: 13px;
color: #ffffff;
text-transform: capitalize;">
                                    Choose File
                                  </label>

                                  <!-- Spinner (optional) -->
                                  <div class="d-flex justify-content-center spinner" v-if="tab.uploadload === true">
                                    <circle-8></circle-8>
                                  </div>

                                  <!-- The input field with a dynamic id based on index -->
                                  <input accept="application/pdf" :id="tab.transporter_id" type="file"
                                    ref="transporterfile" name="transporterfile" class="valid" :multiple="true"
                                    aria-invalid="false" style="display: none"
                                    v-on:change="onFileChangeTransporterSupportDoc($event, tab.transporter_id)"
                                    :disabled="preview" />
                                </div>

                                <div v-if="tab.uploadload == false" style="
              height: 200px;
padding: 0px 20px 20px 0px;
margin: 0px 30px 20px 0px;
" class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                  <div v-for="(file, index) in tab.transporter_support_documents"
                                    :key="'file_transporter_documents_' + index" class="row">
                                    <div class="col-lg-8">
                                      <a :href="file.url">
                                        <base-button class="btn-link btn-primary">
                                          {{ file.meta.filename }}
                                        </base-button>
                                      </a>
                                    </div>
                                    <div class="col-lg-4">
                                      <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                        @click="removeTransporterFile(file.transporter_document_id)"
                                        :disabled="preview">
                                        Remove
                                      </base-button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-6 d-flex" v-if="module == 'vendor'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    DRIVER DETAILS
                                  </p>
                                </div>
                              </div>
                              <div class="col-lg-12" style="height: 330px; overflow-y: auto;">
                                <div :key="'_driver_item_' + index" class="row">
                                  <div class="col-lg-10">
                                    <p class="newtitle">
                                      Add Driver
                                    </p>
                                    <p style="color: #A5A5A5">
                                      Driver Name <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="newname" :class="{ 'custom-input': true }" min="0"
                                        :disabled="preview" />
                                    </div>

                                    <p style="color: #A5A5A5">
                                      NRIC <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="newnric" :class="{ 'custom-input': true }" min="0"
                                        :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-2 d-flex justify-content-center align-items-center">
                                    <base-button class="btn-icon-eprf btn-icon btn-round"
                                      @click="adddriver(tab.drivers, newname, newnric)">
                                      <i class="tim-icons icon-simple-add"></i>
                                    </base-button>
                                  </div>
                                </div>
                                <br />

                                <div v-for="(item, index) in tab.drivers" style="margin-top: 20px;"
                                  :key="'_driver_item_' + item.driver_nric" class="row">
                                  <div class="col-lg-10">
                                    <p class="newtitle">
                                      Driver Details {{ index + 1 }}
                                    </p>
                                    <p style="color: #A5A5A5">
                                      Driver Name <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="item.driver_name" :class="{ 'custom-input': true }"
                                        min="0" :disabled="preview" />
                                    </div>

                                    <p style="color: #A5A5A5">
                                      NRIC <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="item.driver_nric" :class="{ 'custom-input': true }"
                                        min="0" :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-2 d-flex justify-content-center align-items-center">
                                    <base-button class="btn-cancel btn-icon btn-round"
                                      @click="removedriver(tab.drivers, index)">
                                      <i class="tim-icons icon-simple-remove"></i>
                                    </base-button>
                                  </div>
                                </div>
                                <br />
                                <br />
                                <br />
                                <br />

                              </div>
                            </card>
                          </div>
                          <div class="col-lg-6 d-flex" v-if="module == 'vendor'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    TRUCK DETAILS
                                  </p>
                                </div>
                              </div>
                              <div class="col-lg-12" style="height: 330px; overflow-y: auto;">
                                <div class="row" :key="'truck_detail_item_' + index">
                                  <div class="col-lg-10">
                                    <p style="color: #A5A5A5">
                                      Add Truck Registration Number
                                    </p>
                                    <div style="padding-right: 30px">
                                      <!-- v-model="item.vehicle_reg_num" -->
                                      <input type="text" v-model="newtruck" :class="{ 'custom-input': true }" min="0"
                                        :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-2 d-flex justify-content-center align-items-center">
                                    <base-button class="btn-icon-eprf btn-icon btn-round"
                                      @click="addtruck(tab.vehicles, newtruck)"><i
                                        class="tim-icons icon-simple-add"></i></base-button>
                                  </div>
                                </div>
                                <br />

                                <div v-for="(item, index) in tab.vehicles" class="row"
                                  :key="'truck_detail_item_' + item.vehicle_reg_num">
                                  <div class="col-lg-10">
                                    <p style="color: #A5A5A5">
                                      Truck {{ index + 1 }} Registration Number
                                      <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="item.vehicle_reg_num"
                                        :class="{ 'custom-input': true }" min="0" :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-2 d-flex justify-content-center align-items-center">
                                    <base-button class="btn-cancel btn-icon btn-round"
                                      @click="removetruck(tab.vehicles, index)"><i
                                        class="tim-icons icon-simple-remove"></i></base-button>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg"></div>
                    <div class="col-lg-3 text-right">
                      <base-button type="danger" v-on:click="modals.cancelModal = true">Cancel</base-button>&nbsp;

                      <base-button v-if="tab.name == 'Details' || tab.name == 'PIC'" type="primary"
                        v-on:click="handleUpdateVendor(picdetails)">Update
                      </base-button>

                      <base-button v-else type="primary" v-on:click="handleUpdateTransporter(tab)">Update
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </card> -->
            </div>
          </div>

          <div class="tabs" v-if="view == 'add'">
            <div class="tab-content">
              <div v-for="(tab, index) in tabs" :key="index" v-show="activeTab === index">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-12">
                      <div>
                        <div class="row" v-if="module == 'vendor'">
                          <div class="col-lg-6 d-flex" v-if="module != 'authority'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    BASIC DETAILS
                                  </p>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-lg-6">
                                  <p style="color: #A5A5A5">
                                    Company Name <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="companyname" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Company Reg. No. <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="companyregno" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Company Address <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="companyaddress" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">Company Fax Number</p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="companyfaxno" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    Company Phone Number <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="companyphonenumber" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                    <p v-if="iscompanyphonenumber" style="font-size: 12px; color: #EC1B23">
                                      The length of the phone number is insufficient.
                                    </p>
                                  </div>
                                </div>
                                <div class="col-lg-6">
                                  <p style="color: #A5A5A5" v-if="module == 'vendor'">
                                    DOE License No. <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px" v-if="module == 'vendor'">
                                    <input type="text" v-model="doelicense" :class="{ 'custom-input': true }"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5" v-if="module == 'vendor'">
                                    DOE License Expiry <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px" v-if="module == 'vendor'">
                                    <el-date-picker v-model="doeexpired" placeholder="Select"
                                      :disabled="preview"></el-date-picker>
                                  </div>

                                  <p style="color: #A5A5A5" v-if="module == 'vendor'">
                                    Facility Type <span style="color: #EC1B23">*</span>
                                  </p>
                                  <el-select v-if="module == 'vendor'" class="select-info tab select-width"
                                    placeholder="Select" v-model="selects.facility"
                                    style="width: 90%; border-bottom: 1px solid lightgray" filterable
                                    :disabled="preview">
                                    <el-option v-for="re in selects.facilitytypes" class="select-info custom-option"
                                      :value="re.value" :label="re.label" :key="re.value"></el-option>
                                  </el-select>

                                  <p style="color: #A5A5A5" v-if="module == 'land' || module == 'vessel'">
                                    Position <span style="color: #EC1B23">*</span>
                                  </p>
                                  <el-select v-if="module == 'land' || module == 'vessel'"
                                    class="select-info tab select-width" placeholder="Select" v-model="position"
                                    style="width: 90%; border-bottom: 1px solid lightgray" filterable
                                    :disabled="preview">
                                    <el-option v-for="re in selects.positions" class="select-info" :value="re.value"
                                      :label="re.label" :key="re.value"></el-option>
                                  </el-select>
                                </div>
                              </div>
                            </card>
                          </div>

                          <div class="col-lg-6 d-flex" v-if="module == 'vendor'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    SW CODES
                                  </p>
                                </div>
                              </div>
                              <div v-if="update" class="row">
                                <div class="col-lg">
                                  <el-select v-if="module == 'vendor'" class="select-info tab select-width"
                                    placeholder="Select" v-model="selects.sw" @change="addWasteHandle()" style="
                    width: 90%;
                    border-bottom: 1px solid lightgray;
                    color: pink !important;
                  " filterable :disabled="preview">
                                    <el-option v-for="re in selects.swes" class="select-info" :value="re.value"
                                      :label="re.label" :key="re.value"></el-option>
                                  </el-select>
                                </div>
                              </div>
                              <br />
                              <div class="col-lg-12"
                                :style="{ height: !update ? '371px' : '330px', overflowY: 'auto' }">
                                <div v-if="update" class="row">
                                  <div class="col-lg-4 text-center">
                                    <p style="color: #707070;">CODE</p>
                                  </div>
                                  <div class="col-lg-3 text-center">
                                    <p style="color: #707070;">BUY PRICE (RM/Kg)</p>
                                  </div>
                                  <div class="col-lg-3 text-center">
                                    <p style="color: #707070;">SELL PRICE (RM/Kg)</p>
                                  </div>
                                  <div class="col-lg-2 text-center">
                                    <p style="color: #707070;"></p>
                                  </div>
                                </div>

                                <div v-if="!update" class="row">
                                  <div class="col-lg-4 text-center">
                                    <p style="color: #707070;">CODE</p>
                                  </div>
                                  <div class="col-lg-4 text-right">
                                    <p style="color: #707070;">BUY PRICE (RM/Kg)</p>
                                  </div>
                                  <div class="col-lg-4 text-right">
                                    <p style="color: #707070;">SELL PRICE (RM/Kg)</p>
                                  </div>
                                </div>


                                <div v-if="update" class="row" v-for="(item, index) in wastehandle"
                                  :key="'waste_handle_item_' + index">
                                  <div class="col-lg-4 text-center">
                                    <p class="newtitle"
                                      style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ item.waste_type_name }}
                                    </p>
                                  </div>
                                  <div class="col-lg-3">
                                    <div>
                                      <input type="number" v-model="item.buy_price" :class="{ 'custom-input': true }"
                                        min="0" :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-3">
                                    <div>
                                      <input type="number" v-model="item.sell_price" :class="{ 'custom-input': true }"
                                        min="0" :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-2 text-center">
                                    <base-button class="btn-cancel btn-icon btn-round"
                                      @click="wastehandle.splice(item.id, 1)"><i
                                        class="tim-icons icon-simple-remove"></i></base-button>
                                  </div>
                                </div>

                                <div v-if="!update && wastehandle.length != 0" class="row"
                                  v-for="(item, index) in wastehandle" :key="'update_waste_handle_item_' + index">
                                  <div class="col-lg-4 text-center">
                                    <p class="newtitle"
                                      style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      {{ item.waste_type_name }}
                                    </p>
                                  </div>
                                  <div class="col-lg-4 text-center">
                                    <p class="newtitle" style="text-align: right">
                                      {{ item.buy_price }}
                                    </p>
                                  </div>
                                  <div class="col-lg-4 text-center">
                                    <p class="newtitle" style="text-align: right">
                                      {{ item.sell_price }}
                                    </p>
                                  </div>
                                </div>

                                <div v-if="!update && wastehandle.length === 0" class="row">
                                  <div class="col-lg-11 text-center">
                                    <p class="newtitle"
                                      style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                      No data
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <br />
                              <div class="row">
                                <div class="col-lg"></div>
                                <div v-if="update" class="col-lg-6 text-right">
                                  <base-button v-if="preview == false" type="primary" @click="updateWasteHandle">Update
                                  </base-button>
                                </div>
                                <div v-if="!update" class="col-lg-6 text-right">
                                  <base-button v-if="preview == false" type="primary" @click="update = !update">Edit
                                  </base-button>
                                </div>
                              </div>
                            </card>
                          </div>

                          <div class="col-lg-6 d-flex" v-if="module != 'authority'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg-12">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    TRANSPORTER DETAILS

                                  </p>
                                </div>

                              </div>
                              <div class="col-lg-12">

                                <div class="row">
                                  <div class="col-lg-12">

                                    <p style="color: #A5A5A5">
                                      Transporter Name <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="newtransname" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-12">

                                    <p style="color: #A5A5A5">
                                      DOE No <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="newtransdoeno" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-12">

                                    <p style="color: #A5A5A5">
                                      Transporter Address <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="newtransaddress" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-12">

                                    <p style="color: #A5A5A5">
                                      Transporter Phone No. <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="newtransphoneno" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                      <p v-if="istransporterphoneno" style="font-size: 12px; color: #EC1B23">
                                        The length of the phone number is insufficient.
                                      </p>
                                    </div>
                                  </div>
                                  <div class="col-lg-12">

                                    <p style="color: #A5A5A5">Transporter Fax</p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="newtransfaxno" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>
                                  </div>

                                  <br /><br /><br />
                                  <div class="row">
                                    <div class="col-lg"></div>
                                    <div class="col-lg-6 text-right">
                                      <!-- <base-button type="primary" @click="saveTransporter(transporterdetails, index)">Save -->
                                      <!-- </base-button> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-6 d-flex" v-if="module == 'vendor'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    UPLOAD TRANSPORTER SUPPORT DOCUMENT

                                  </p>
                                </div>
                              </div>
                              <div class="col-lg-12"
                                :style="{ height: !update ? '371px' : '330px', overflowY: 'auto' }">
                                <div :key="'doc' + index" class="fileinput">
                                  <!-- The label is connected to the input with a dynamic id based on index -->
                                  <label :for="'transporter-upload-' + index" type="primary" class="btn" style="
font-size: 13px;
color: #ffffff;
text-transform: capitalize;">
                                    Choose File
                                  </label>

                                  <!-- Spinner (optional) -->
                                  <div class="d-flex justify-content-center spinner" v-if="docload === true">
                                    <circle-8></circle-8>
                                  </div>

                                  <!-- The input field with a dynamic id based on index -->
                                  <input accept="application/pdf" :id="'transporter-upload-' + index" type="file"
                                    ref="transporterfile" name="transporterfile" class="valid" :multiple="true"
                                    aria-invalid="false" style="display: none"
                                    v-on:change="onFileChange($event, 'transporter_support_document')"
                                    :disabled="preview" />
                                </div>

                                <div v-if="docload == false" style="
              height: 200px;
padding: 0px 20px 20px 0px;
margin: 0px 30px 20px 0px;
" class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                  <div v-for="(file, index) in newtransdocs"
                                    :key="'file_transporter_documents_' + index" class="row">
                                    <div class="col-lg-8">
                                      <a :href="file.url">
                                        <base-button class="btn-link btn-primary">
                                          {{ file.filename }}
                                        </base-button>
                                      </a>
                                    </div>
                                    <div class="col-lg-4">
                                      <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                        @click="removeFile(file.document_id, 'transporter_support_document')"
                                        :disabled="preview">
                                        Remove
                                      </base-button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-6 d-flex" v-if="module == 'vendor'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    DRIVER DETAILS
                                  </p>
                                </div>
                              </div>
                              <div class="col-lg-12" style="height: 330px; overflow-y: auto;">
                                <div :key="'_driver_item_' + index" class="row">
                                  <div class="col-lg-10">
                                    <p class="newtitle">
                                      Add Driver
                                    </p>
                                    <p style="color: #A5A5A5">
                                      Driver Name <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="newname" :class="{ 'custom-input': true }" min="0"
                                        :disabled="preview" />
                                    </div>

                                    <p style="color: #A5A5A5">
                                      NRIC <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="newnric" :class="{ 'custom-input': true }" min="0"
                                        :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-2 d-flex justify-content-center align-items-center">
                                    <base-button class="btn-icon-eprf btn-icon btn-round"
                                      @click="addnewdriver(newname, newnric)">
                                      <i class="tim-icons icon-simple-add"></i>
                                    </base-button>
                                  </div>
                                </div>
                                <br />

                                <div v-for="(item, index) in newdriver" style="margin-top: 20px;"
                                  :key="'_driver_item_' + item.driver_nric" class="row">
                                  <div class="col-lg-10">
                                    <p class="newtitle">
                                      Driver Details {{ index + 1 }}
                                    </p>
                                    <p style="color: #A5A5A5">
                                      Driver Name <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="item.driver_name" :class="{ 'custom-input': true }"
                                        min="0" :disabled="preview" />
                                    </div>

                                    <p style="color: #A5A5A5">
                                      NRIC <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="item.driver_nric" :class="{ 'custom-input': true }"
                                        min="0" :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-2 d-flex justify-content-center align-items-center">
                                    <base-button class="btn-cancel btn-icon btn-round" @click="removenewdriver(index)">
                                      <i class="tim-icons icon-simple-remove"></i>
                                    </base-button>
                                  </div>
                                </div>
                                <br />
                                <br />
                                <br />
                                <br />

                              </div>
                            </card>
                          </div>
                          <div class="col-lg-6 d-flex" v-if="module == 'vendor'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    TRUCK DETAILS
                                  </p>
                                </div>
                              </div>
                              <div class="col-lg-12" style="height: 330px; overflow-y: auto;">
                                <div class="row" :key="'truck_detail_item_' + index">
                                  <div class="col-lg-10">
                                    <p style="color: #A5A5A5">
                                      Add Truck Registration Number
                                    </p>
                                    <div style="padding-right: 30px">
                                      <!-- v-model="item.vehicle_reg_num" -->
                                      <input type="text" v-model="newtruck" :class="{ 'custom-input': true }" min="0"
                                        :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-2 d-flex justify-content-center align-items-center">
                                    <base-button class="btn-icon-eprf btn-icon btn-round"
                                      @click="addnewtruck(newtruck)"><i
                                        class="tim-icons icon-simple-add"></i></base-button>
                                  </div>
                                </div>
                                <br />

                                <div v-for="(item, index) in newtrucks" class="row"
                                  :key="'truck_detail_item_' + item.vehicle_reg_num">
                                  <div class="col-lg-10">
                                    <p style="color: #A5A5A5">
                                      Truck {{ index + 1 }} Registration Number
                                      <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="item.vehicle_reg_num"
                                        :class="{ 'custom-input': true }" min="0" :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-2 d-flex justify-content-center align-items-center">
                                    <base-button class="btn-cancel btn-icon btn-round" @click="removenewtruck(index)"><i
                                        class="tim-icons icon-simple-remove"></i></base-button>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>

                          <div class="col-lg-3 d-flex">
                            <card class="card-eprf">
                              <br />

                              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                UPLOAD COMPANY SUPPORT DOCUMENT
                              </p>
                              <p class="newtitle">Choose File from Your Desktop</p>
                              <p class="sub-title">
                                Please upload any existing contract for recurring job request
                              </p>
                              <div class="fileinput">
                                <label for="invoice-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                                  Choose File
                                </label>
                                <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
                                <div class="d-flex justify-content-center spinner" v-if="compsupdoc == true">
                                  <circle-8></circle-8>
                                </div>

                                <input accept="application/pdf" id="invoice-upload" type="file" ref="invoicefile"
                                  name="..." class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                  v-on:change="onFileChange1($event, 'company_support_document')" :disabled="preview" />
                              </div>
                              <div v-if="compsupdoc == false" style="
                height: 200px;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                <div v-for="(file, index) in newsupportdoc" :key="'file_allinvoice_' + index"
                                  class="row">
                                  <div class="col-lg-8">
                                    <a :href="file.fileurl">
                                      <base-button class="btn-link btn-primary">
                                        {{ file.filename }}
                                      </base-button>
                                    </a>
                                  </div>
                                  <div class="col-lg-4">
                                    <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                      @click="removeFile1(file.fileid, 'company_support_document')" :disabled="preview">
                                      Remove
                                    </base-button>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-3 d-flex">
                            <card class="card-eprf">
                              <br />

                              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                UPLOAD DOE SUPPORT DOCUMENT
                              </p>
                              <p class="newtitle">Choose File from Your Desktop</p>
                              <p class="sub-title">
                                Please upload any existing contract for recurring job request
                              </p>
                              <div class="fileinput">
                                <label for="doe-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                                  Choose File
                                </label>
                                <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
                                <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                                  <circle-8></circle-8>
                                </div>

                                <input accept="application/pdf" id="doe-upload" type="file" ref="doefile" name="..."
                                  class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                  v-on:change="onFileChange2($event, 'doe_support_document')" :disabled="preview" />
                              </div>
                              <div v-if="uploadload == false" style="
                height: 200px;;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                <div v-for="(file, index) in newdoedoc" :key="'file_alldoe_' + index" class="row">
                                  <div class="col-lg-8">
                                    <a :href="file.fileurl">
                                      <base-button class="btn-link btn-primary">
                                        {{ file.filename }}
                                      </base-button>
                                    </a>
                                  </div>
                                  <div class="col-lg-4">
                                    <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                      @click="removeFile2(file.fileid, 'doe_support_document')" :disabled="preview">
                                      Remove
                                    </base-button>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>

                          <div class="col-lg-3 d-flex" v-for="(item, index) in picdetails" :key="item.useremail">
                            <card class="card-eprf">
                              <br />
                              <div class="row">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    PIC DETAILS - {{ index + 1 }}
                                  </p>
                                </div>
                                <div class="col-lg-2 text-right">
                                  <base-button class="btn-cancel btn-icon btn-round" @click="removepic(index)"><i
                                      class="tim-icons icon-simple-remove"></i></base-button>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-lg">
                                  <p style="color: #A5A5A5">
                                    User name <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.username" :class="{ 'custom-input': true }" min="0"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    User Email <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.useremail" :class="{ 'custom-input': true }"
                                      min="0" :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    User Phone Number <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.userphonenumber" :class="{ 'custom-input': true }"
                                      min="0" :disabled="preview" />
                                    <p v-if="item.userphonenumber.length <= 7" style="font-size: 12px; color: #EC1B23">
                                      The length of the phone number is insufficient.
                                    </p>
                                  </div>

                                  <p style="color: #A5A5A5">User Fax Number</p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.userfaxnumber" :class="{ 'custom-input': true }"
                                      min="0" :disabled="preview" />
                                  </div>
                                  <p style="color: #A5A5A5" v-if="view == 'add' || item.flag == 'new'">
                                    Password <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div class="col-lg-12">
                                    <div class="row" v-if="view == 'add' || item.flag == 'new'">
                                      <input class="col-lg" v-if="item.showPassword1" type="text"
                                        v-model="item.password" :class="{ 'custom-input': true }" />
                                      <input class="col-lg" v-else type="password" v-model="item.password"
                                        @focus="short = true" :class="{ 'custom-input': true }" />
                                      <button class="custom-button" @click="toggleShoww1(index)">
                                        <span class="icon is-small is-right">
                                          <i class="fas" :class="{
          'fa-eye-slash': item.showPassword1,
          'fa-eye': !item.showPassword1,
        }"></i>
                                        </span>
                                      </button>

                                      <el-tooltip class="col-lg-1" effect="light" :open-delay="300" placement="top">
                                        <template v-slot:content>
                                          <div style="display: flex">
                                            <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                                              <i v-if="!item.alphanumeric" class="fas fa-times-circle red-circle"></i>
                                              <i v-if="item.alphanumeric" class="fas fa-check-circle green-circle"></i>
                                              At least 8 alphanumeric characters
                                            </p>
                                            &nbsp;&nbsp;
                                          </div>
                                          <div style="display: flex">
                                            <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                                              <i v-if="!item.upperlower" class="fas fa-times-circle red-circle"></i>
                                              <i v-if="item.upperlower" class="fas fa-check-circle green-circle"></i>
                                              Must include uppercase and lowercase
                                            </p>
                                          </div>
                                          <div style="display: flex">
                                            <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                                              <i v-if="!item.special" class="fas fa-times-circle red-circle"></i>
                                              <i v-if="item.special" class="fas fa-check-circle green-circle"></i>
                                              Must include symbol (e.g. !@#$%^&*)
                                            </p>
                                          </div>
                                        </template>
                                        <base-button type="link">
                                          <i class="tim-icons icon-alert-circle-exc"></i>
                                        </base-button>
                                      </el-tooltip>
                                    </div>
                                  </div>

                                  <p style="color: #A5A5A5" v-if="view == 'add' || item.flag == 'new'">
                                    Confirm Password <span style="color: #EC1B23">*</span>
                                  </p>

                                  <div style="padding-right: 30px; display: flex"
                                    v-if="view == 'add' || item.flag == 'new'">
                                    <input v-if="item.showPassword" type="text" v-model="item.confirmpassword"
                                      @focus="item.showPasswordMismatch = true" :class="{ 'custom-input': true }" />
                                    <input v-else type="password" v-model="item.confirmpassword"
                                      :class="{ 'custom-input': true }" />
                                    <button class="custom-button" @click="toggleShoww(index)">
                                      <span class="icon is-small is-right">
                                        <i class="fas" :class="{
          'fa-eye-slash': item.showPassword,
          'fa-eye': !item.showPassword,
        }"></i>
                                      </span>
                                    </button>
                                  </div>

                                  <div style="display: flex; height: 30px" v-if="view == 'add' || item.flag == 'new'">
                                    <p v-if="item.showPasswordMismatch &&
          item.confirmpassword !== item.password
          " style="font-size: 11px; color: #ea2127">
                                      {{ item.pwdmessage }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-3 d-flex">
                            <card class="card-eprf">
                              <br />
                              <div class="row">
                                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                  ADD PIC
                                </p>
                              </div>
                              <br />
                              <br />
                              <div class="row">
                                <div class="col-lg text-center">
                                  <base-button class="btn-icon-eprf btn-link" @click="addpic()" :disabled="preview"><img
                                      src="@/assets/img/plus.png" width="230" />
                                  </base-button>
                                </div>
                              </div>
                            </card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>



                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg"></div>
                    <div class="col-lg-3 text-right">
                      <base-button type="danger" v-on:click="modals.cancelModal = true">Cancel</base-button>&nbsp;

                      <base-button type="primary" v-on:click="handleAddVendor(picdetails)">Submit
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </card> -->
            </div>
          </div>
        </div>
      </div>



      <div class="row" v-if="module == 'afes'">
        <div class="col-lg">
          <card class="card-eprf">
            <div class="row" style="display: flex">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  BASIC DETAILS
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <p style="color: #A5A5A5">
                  User name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="fullname" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>


                <p style="padding-top: 50px; color: #A5A5A5" v-if="view == 'add'">
                  Password <span style="color: #EC1B23">*</span>
                </p>
                <div class="col-lg-12">
                  <div class="row" v-if="view == 'add'">
                    <input class="col-lg" v-if="showPassword1" type="text" v-model="password"
                      :class="{ 'custom-input': true }" />
                    <input class="col-lg" v-else type="password" v-model="password" @focus="short = true"
                      :class="{ 'custom-input': true }" />
                    <button class="custom-button" @click="toggleShow1">
                      <span class="icon is-small is-right">
                        <i class="fas" :class="{
          'fa-eye-slash': showPassword1,
          'fa-eye': !showPassword1,
        }"></i>
                      </span>
                    </button>
                    <el-tooltip class="col-lg-1" effect="light" :open-delay="300" placement="top">
                      <template v-slot:content>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!alphanumeric" class="fas fa-times-circle red-circle"></i>
                            <i v-if="alphanumeric" class="fas fa-check-circle green-circle"></i>
                            At least 8 alphanumeric characters
                          </p>
                          &nbsp;&nbsp;
                        </div>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!upperlower" class="fas fa-times-circle red-circle"></i>
                            <i v-if="upperlower" class="fas fa-check-circle green-circle"></i>
                            Must include uppercase and lowercase
                          </p>
                        </div>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!special" class="fas fa-times-circle red-circle"></i>
                            <i v-if="special" class="fas fa-check-circle green-circle"></i>
                            Must include symbol (e.g. !@#$%^&*)
                          </p>
                        </div>
                      </template>
                      <base-button type="link">
                        <i class="tim-icons icon-alert-circle-exc"></i>
                      </base-button>
                    </el-tooltip>
                  </div>
                  <div style="padding-left: 500px; display: flex">
                  </div>
                </div>


                <p style="padding-top: 50px; color: #A5A5A5" v-if="view == 'add'">
                  Confirm Password <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px; display: flex" v-if="view == 'add'">
                  <input v-if="showPassword" type="text" v-model="confirmpassword" @focus="showPasswordMismatch = true"
                    :class="{ 'custom-input': true }" />
                  <input v-else type="password" v-model="confirmpassword" @focus="showPasswordMismatch = true"
                    :class="{ 'custom-input': true }" />
                  <button class="custom-button" @click="toggleShow">
                    <span class="icon is-small is-right">
                      <i class="fas" :class="{
          'fa-eye-slash': showPassword,
          'fa-eye': !showPassword,
        }"></i>
                    </span>
                  </button>
                </div>
                <div style="display: flex; height: 30px" v-if="view == 'add'">
                  <p v-if="showPasswordMismatch && confirmpassword !== password" style="font-size: 12px; color: #EC1B23">
                    Password mismatch.
                  </p>
                </div>

                <p style="padding-top: 50px; color: #A5A5A5">
                  Phone No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="phoneno" :class="{ 'custom-input': true }" :disabled="preview" />

                  <p v-if="isphoneno" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <div v-if="selects.usertype === 4">
                  <p style="padding-top: 50px; padding-bottom: 10px; color: #A5A5A5">
                    Digital Signature <span style="color: #EC1B23">*</span> <span
                      style="font-style: italic; font-size: 11px; color: #A5A5A5;">Please upload image with size 300x150
                      (2:1)</span>
                  </p>

                  <div class="row">
                    <div class="col-lg-3">
                      <label for="image-upload">
                        <div
                          style="border-radius: 10px; display: flex; align-items: center; justify-content: center; border: 1px dashed #358CCB; width: 310px; height: 160px;">

                          <input accept="image/*" id="image-upload" type="file" ref="imageupload" name="..."
                            class="valid" aria-invalid="false" style="display: none" @change="onImagesChange" />

                          <div v-if="!image">
                            <i style="color: #A5A5A5; font-size: 40px; font-weight: 700"
                              class="tim-icons icon-camera-18"></i>

                          </div>
                          <div v-if="image">
                            <div class="image-container">
                              <img :src="image.url" class="digital-signature" />
                              <img src="@/assets/img/sample.png" class="sample-signature" />
                            </div>
                            <div style="position: absolute; right: -140%; top: 0">
                              <base-button class="btn-icon btn-cancel btn-round btn-xs" @click="removeImages(image.id)">
                                <i class="fa fa-times" aria-hidden="true"></i>
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div v-if="load" class="loading-bar">
                      <div class="loading-bar-progress" :style="{ width: loadingPercentage + '%' }"></div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-lg-4">
                <p style="color: #A5A5A5">
                  Email <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="email" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>
                <p style="color: #A5A5A5; font-size: 10px; margin-top: -1px">
                  {{ this.email_unique }}
                </p>

                <p style="padding-top: 50px; color: #A5A5A5">
                  User Type <span style="color: #EC1B23">*</span>
                </p>
                <el-select class="select-info tab select-width" placeholder="Select" v-model="selects.usertype"
                  style="width: 90%; border-bottom: 1px solid lightgray" :disabled="preview" filterable>
                  <el-option v-for="option in selects.usertypes" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>

                <p style="padding-top: 50px; color: #A5A5A5" v-if="selects.usertype == 2">
                  Service Location <span style="color: #EC1B23">*</span>
                </p>
                <el-select v-if="selects.usertype == 2" class="select-info tab select-width" placeholder="Select"
                  v-model="selects.servicelocation" style="width: 90%; border-bottom: 1px solid lightgray"
                  :disabled="preview" filterable>
                  <el-option v-for="option in selects.servicelocations" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>

                <p style="padding-top: 80px; color: #A5A5A5">
                  Staff ID <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="staffID" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="padding-top: 80px; color: #A5A5A5">Remarks (if any)</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="remarks" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div v-if="module == 'vessel'">
        <div id="app">
          <div class="tabs" v-if="view !== 'add'">
            <div class="tab-container" style="display: flex; align-items: center;">
              <div class="tab-list"
                style="display: inline-flex; overflow-x: auto; flex-grow: 1; padding-right: 10px; border-bottom: 1px solid #ccc;">
                <div v-for="(tab, index) in vesseltabs" :key="index" :class="{
          'first-tabb': index === 0,
          'other-tabb': index !== 0 && index !== 5,
          'last-tabb': index === 5,
          'inactive-tabb': activeTab !== index,
        }" @click="activeTab = index" style="flex-shrink: 0;">
                  <p :class="{
          'active-tabb-title': activeTab === index,
          'inactive-tabb-title': activeTab !== index,
        }">
                    {{ tab.name }}
                  </p>
                </div>
              </div>
              <div class="col-lg-1 d-flex justify-content-center align-items-center" style="flex-shrink: 0;">
                <base-button class="btn-icon-eprf btn-icon btn-round" title="Add a new ship"
                  @click="modals.addShip = true">
                  <i class="tim-icons icon-simple-add"></i>
                </base-button>
              </div>
            </div>
            <br />

            <div class="tab-content">
              <div v-for="(tab, index) in vesseltabs" :key="index" v-show="activeTab === index">
                <div v-if="tab.name == 'Details'" class="full-size-container">
                  <div class="row">
                    <div class="col-lg-12">
                      <div>
                        <div class="row">
                          <div class="col-lg-6 d-flex" v-if="module != 'authority'">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    BASIC DETAILS
                                  </p>
                                </div>
                              </div>
                              <div class="col-lg-12">

                                <div class="row">
                                  <div class="col-lg-6">
                                    <div class="col-lg-12">
                                      <p style="color: #A5A5A5">
                                        Company Name <span style="color: #EC1B23">*</span>
                                      </p>
                                      <div style="padding-right: 30px">
                                        <input type="text" v-model="companyname" :class="{ 'custom-input': true }"
                                          :disabled="preview" />
                                      </div>
                                    </div>

                                    <div class="col-lg-12">
                                      <p style="color: #A5A5A5">
                                        Company Reg. No. <span style="color: #EC1B23">*</span>
                                      </p>
                                      <div style="padding-right: 30px">
                                        <input type="text" v-model="companyregno" :class="{ 'custom-input': true }"
                                          :disabled="preview" />
                                      </div>
                                    </div>

                                    <p style="color: #A5A5A5">
                                      Company Address <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="companyaddress" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>

                                    <p style="color: #A5A5A5">Company Fax Number</p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="companyfaxno" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>

                                    <p style="color: #A5A5A5">
                                      Company Phone Number <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="companyphonenumber" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                      <p v-if="iscompanyphonenumber" style="font-size: 12px; color: #EC1B23">
                                        The length of the phone number is insufficient.
                                      </p>
                                    </div>
                                  </div>
                                  <div class="col-lg-6">
                                    <p style="color: #A5A5A5" v-if="module == 'vendor'">
                                      DOE License No. <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px" v-if="module == 'vendor'">
                                      <input type="text" v-model="doelicense" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>

                                    <p style="color: #A5A5A5" v-if="module == 'vendor'">
                                      DOE License Expiry <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px" v-if="module == 'vendor'">
                                      <el-date-picker v-model="doeexpired" placeholder="Select"
                                        :disabled="preview"></el-date-picker>
                                    </div>

                                    <p style="color: #A5A5A5" v-if="module == 'vendor'">
                                      Facility Type <span style="color: #EC1B23">*</span>
                                    </p>
                                    <el-select v-if="module == 'vendor'" class="select-info tab select-width"
                                      placeholder="Select" v-model="selects.facility"
                                      style="width: 90%; border-bottom: 1px solid lightgray" filterable
                                      :disabled="preview">
                                      <el-option v-for="re in selects.facilitytypes" class="select-info custom-option"
                                        :value="re.value" :label="re.label" :key="re.value"></el-option>
                                    </el-select>

                                    <p style="color: #A5A5A5" v-if="module == 'land' || module == 'vessel'">
                                      Position <span style="color: #EC1B23">*</span>
                                    </p>
                                    <el-select v-if="module == 'land' || module == 'vessel'"
                                      class="select-info tab select-width" placeholder="Select" v-model="position"
                                      style="width: 90%; border-bottom: 1px solid lightgray" filterable
                                      :disabled="preview">
                                      <el-option v-for="re in selects.positions" class="select-info" :value="re.value"
                                        :label="re.label" :key="re.value"></el-option>
                                    </el-select>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>

                          <div class="col-lg-3 d-flex" v-if="view !== 'add' && module == 'authority'">
                            <card class="card-eprf">
                              <br />

                              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                UPLOAD AUTHORITY SUPPORT DOCUMENT
                              </p>
                              <p class="newtitle">Choose File from Your Desktop</p>
                              <!-- <p class="sub-title">
              Please upload any existing contract for recurring job request
            </p> -->
                              <div class="fileinput">
                                <label for="authority-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                                  Choose File
                                </label>
                                <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
                                <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                                  <circle-8></circle-8>
                                </div>

                                <input accept="application/pdf" id="authority-upload" type="file" ref="authorityfile"
                                  name="..." class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                  v-on:change="onInvoiceChange5" :disabled="preview" />
                              </div>
                              <div v-if="uploadload == false" style="
                height: 200px;;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                <div v-for="(file, index) in allauthority" :key="'file_allauthority_' + index"
                                  class="row">
                                  <div class="col-lg-8">
                                    <a :href="file.fileurl">
                                      <base-button class="btn-link btn-primary">
                                        {{ file.filename }}
                                      </base-button>
                                    </a>
                                  </div>
                                  <div class="col-lg-4">
                                    <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                      @click="removeAuthorityFile(file.fileid)" :disabled="preview">
                                      Remove
                                    </base-button>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-3 d-flex">
                            <card class="card-eprf">
                              <br />
                              <!-- <div class="col-lg-12"> -->

                              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                UPLOAD COMPANY SUPPORT DOCUMENT
                              </p>
                              <p class="newtitle">Choose File from Your Desktop</p>
                              <p class="sub-title">
                                Please upload any existing contract for recurring job request
                              </p>
                              <div class="fileinput">
                                <label for="invoice-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                                  Choose File
                                </label>
                                <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
                                <div class="d-flex justify-content-center spinner" v-if="compsupdoc == true">
                                  <circle-8></circle-8>
                                </div>

                                <input accept="application/pdf" id="invoice-upload" type="file" ref="invoicefile"
                                  name="..." class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                  v-on:change="onFileChangeCompanySupportDoc" :disabled="preview" />
                              </div>
                              <div v-if="compsupdoc == false" style="
                height: 200px;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                <div v-for="(file, index) in allInvoice" :key="'file_allinvoice_' + index" class="row">
                                  <div class="col-lg-8">
                                    <a :href="file.fileurl">
                                      <base-button class="btn-link btn-primary">
                                        {{ file.filename }}
                                      </base-button>
                                    </a>
                                  </div>
                                  <div class="col-lg-4">
                                    <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                      @click="removecompanyfile(file.fileid)" :disabled="preview">
                                      Remove
                                    </base-button>
                                  </div>
                                </div>
                                <!-- </div> -->
                              </div>
                            </card>
                          </div>
                          <div class="col-lg-3 d-flex">
                            <card class="card-eprf">
                              <br />
                              <div class="col-lg-12">

                                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                  UPLOAD DOE SUPPORT DOCUMENT
                                </p>
                                <p class="newtitle">Choose File from Your Desktop</p>
                                <p class="sub-title">
                                  Please upload any existing contract for recurring job request
                                </p>
                                <div class="fileinput">
                                  <label for="doe-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                                    Choose File
                                  </label>
                                  <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
                                  <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                                    <circle-8></circle-8>
                                  </div>

                                  <input accept="application/pdf" id="doe-upload" type="file" ref="doefile" name="..."
                                    class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                    v-on:change="onFileChangeDoeDoc" :disabled="preview" />
                                </div>
                                <div v-if="uploadload == false" style="
                height: 200px;;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                  <div v-for="(file, index) in alldoe" :key="'file_alldoe_' + index" class="row">
                                    <div class="col-lg-8">
                                      <a :href="file.fileurl">
                                        <base-button class="btn-link btn-primary">
                                          {{ file.filename }}
                                        </base-button>
                                      </a>
                                    </div>
                                    <div class="col-lg-4">
                                      <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                        @click="removeDoeDoc(file.fileid)" :disabled="preview">
                                        Remove
                                      </base-button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>

                          <div v-if="view == 'add'" class="col-lg-3 d-flex" v-for="(item, index) in picdetails"
                            :key="item.useremail">
                            <card class="card-eprf">
                              <br />
                              <div class="row">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    PIC DETAILS - {{ index + 1 }}
                                  </p>
                                </div>
                                <div class="col-lg-2 text-right">
                                  <base-button class="btn-cancel btn-icon btn-round" @click="removepic(index)"><i
                                      class="tim-icons icon-simple-remove"></i></base-button>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-lg">
                                  <p style="color: #A5A5A5">
                                    User name <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.username" :class="{ 'custom-input': true }" min="0"
                                      :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    User Email <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.useremail" :class="{ 'custom-input': true }"
                                      min="0" :disabled="preview" />
                                  </div>

                                  <p style="color: #A5A5A5">
                                    User Phone Number <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.userphonenumber" :class="{ 'custom-input': true }"
                                      min="0" :disabled="preview" />
                                    <p v-if="item.userphonenumber.length <= 7" style="font-size: 12px; color: #EC1B23">
                                      The length of the phone number is insufficient.
                                    </p>
                                  </div>

                                  <p style="color: #A5A5A5">User Fax Number</p>
                                  <div style="padding-right: 30px">
                                    <input type="text" v-model="item.userfaxnumber" :class="{ 'custom-input': true }"
                                      min="0" :disabled="preview" />
                                  </div>
                                  <p style="color: #A5A5A5" v-if="view == 'add' || item.flag == 'new'">
                                    Password <span style="color: #EC1B23">*</span>
                                  </p>
                                  <div class="col-lg-12">
        <div class="row" v-if="view == 'add' || item.flag == 'new'">
                                      <input class="col-lg" v-if="item.showPassword1" type="text" v-model="item.password"
                                        :class="{ 'custom-input': true }" />
                                      <input class="col-lg" v-else type="password" v-model="item.password" @focus="short = true"
                                        :class="{ 'custom-input': true }" />
                                      <button class="custom-button" @click="toggleShoww1(index)">
                                        <span class="icon is-small is-right">
                                          <i class="fas" :class="{
          'fa-eye-slash': item.showPassword1,
          'fa-eye': !item.showPassword1,
        }"></i>
                                        </span>
                                      </button>
                                      <!-- </div> -->
                                      <!-- <div v-if="view == 'add' || item.flag == 'new'" style="padding-left: 330px; display: flex"> -->
                                      <el-tooltip class="col-lg-1" effect="light" :open-delay="300" placement="top">
                                        <template v-slot:content>
                                          <div style="display: flex">
                                            <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                                              <i v-if="!item.alphanumeric" class="fas fa-times-circle red-circle"></i>
                                              <i v-if="item.alphanumeric" class="fas fa-check-circle green-circle"></i>
                                              At least 8 alphanumeric characters
                                            </p>
                                            &nbsp;&nbsp;
                                          </div>
                                          <div style="display: flex">
                                            <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                                              <i v-if="!item.upperlower" class="fas fa-times-circle red-circle"></i>
                                              <i v-if="item.upperlower" class="fas fa-check-circle green-circle"></i>
                                              Must include uppercase and lowercase
                                            </p>
                                          </div>
                                          <div style="display: flex">
                                            <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                                              <i v-if="!item.special" class="fas fa-times-circle red-circle"></i>
                                              <i v-if="item.special" class="fas fa-check-circle green-circle"></i>
                                              Must include symbol (e.g. !@#$%^&*)
                                            </p>
                                          </div>
                                        </template>
                                        <base-button type="link">
                                          <i class="tim-icons icon-alert-circle-exc"></i>
                                        </base-button>
                                      </el-tooltip>
                                    </div>
                                  </div>

                                  <p style="color: #A5A5A5" v-if="view == 'add' || item.flag == 'new'">
                                    Confirm Password <span style="color: #EC1B23">*</span>
                                  </p>

                                  <div style="padding-right: 30px; display: flex"
                                    v-if="view == 'add' || item.flag == 'new'">
                                    <input v-if="item.showPassword" type="text" v-model="item.confirmpassword"
                                      @focus="item.showPasswordMismatch = true" :class="{ 'custom-input': true }" />
                                    <input v-else type="password" v-model="item.confirmpassword"
                                      :class="{ 'custom-input': true }" />
                                    <button class="custom-button" @click="toggleShoww(index)">
                                      <span class="icon is-small is-right">
                                        <i class="fas" :class="{
          'fa-eye-slash': item.showPassword,
          'fa-eye': !item.showPassword,
        }"></i>
                                      </span>
                                    </button>
                                  </div>

                                  <div style="display: flex; height: 30px" v-if="view == 'add' || item.flag == 'new'">
                                    <p v-if="item.showPasswordMismatch &&
          item.confirmpassword !== item.password
          " style="font-size: 11px; color: #ea2127">
                                      {{ item.pwdmessage }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                          <div v-if="view == 'add'" class="col-lg-3 d-flex">
                            <card class="card-eprf">
                              <br />
                              <div class="row">
                                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                  ADD PIC
                                </p>
                              </div>
                              <br />
                              <br />
                              <div class="row">
                                <div class="col-lg text-center">
                                  <base-button class="btn-icon-eprf btn-link" @click="addpic()" :disabled="preview"><img
                                      src="@/assets/img/plus.png" width="230" />
                                  </base-button>
                                </div>
                              </div>
                            </card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else-if="tab.name == 'PIC'" class="full-size-container">
                  <div class="row">
                    <div class="col-lg-12" v-if="view !== 'add' && module == 'vessel'">
                      <card class="card-eprf">
                        <br />
                        <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                          PIC DETAILS
                        </p>
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-lg-9"></div>
                            <div class="col-lg-3 text-right">
                              <base-button title="Add a new PIC" type="primary" v-on:click="modals.addPIC = true">Add
                                PIC
                              </base-button>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12 text-center">
                          <el-table :data="picdetails" style="width: 100%" height="700" :header-cell-style="{
          background: 'transparent',
          color: 'gray',
        }" class="custom-table">
                            <el-table-column :min-width="50" align="center" label="No">
                              <div slot-scope="scope">
                                {{ scope.$index + 1 }}
                              </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="center" label="Username"
                              prop="username"></el-table-column>
                            <el-table-column :min-width="200" align="center" label="Useremail"
                              prop="useremail"></el-table-column>
                            <el-table-column :min-width="200" align="center" label="Phone Number"
                              prop="userphonenumber"></el-table-column>
                            <el-table-column :min-width="200" align="center" label="Fax Number"
                              prop="userfaxnumber"></el-table-column>
                            <el-table-column :min-width="80" align="center">
                              <div slot-scope="scope">
                                <i style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: #A5A5A5;
                    font-size: 15px;
                    font-weight: 900;
                    cursor: pointer;
                  " @click="editpic(scope.$index, scope.row.username, scope.row.useremail, scope.row.userphonenumber, scope.row.userfaxnumber,)"
                                  class="tim-icons icon-pencil"></i>
                              </div>
                            </el-table-column>
                            <el-table-column :min-width="80" align="center">
                              <div slot-scope="scope">
                                <i style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: #EC1B23;
                    font-size: 15px;
                    font-weight: 900;
                    cursor: pointer;
                  " @click="removepicc(scope.$index)" class="tim-icons icon-trash-simple"></i>
                              </div>
                            </el-table-column>
                          </el-table>
                        </div>
                      </card>
                    </div>
                  </div>
                </div>

                <div v-else class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-12">
                      <div>
                        <div class="row" v-if="module == 'vessel'">
                          <div class="col-lg-6 d-flex" v-if="module == 'vessel'" :key="'vessel_ship_detail_' + index">
                            <card class="card-eprf">
                              <br />
                              <div class="row" style="display: flex">
                                <div class="col-lg">
                                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                    SHIP DETAILS {{ tab.ship_id }}
                                  </p>
                                </div>
                                <div class="col-lg-2 text-right">
                                  <base-button class="btn-icon btn-round btn-cancel" @click="deleteship(tab.ship_id)"><i
                                      class="tim-icons icon-simple-remove"></i>
                                  </base-button>
                                </div>
                              </div>
                              <div class="col-lg-12">
                                <div class="row">

                                  <div class="col-lg-12">
                                    <p style="color: #A5A5A5">
                                      Ship Name <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="tab.shipname" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>
                                  </div>
                                  <div class="col-lg-12">
                                    <p style="color: #A5A5A5">
                                      Ship Type <span style="color: #EC1B23">*</span>
                                    </p>
                                    <el-select class="select-info tab select-width" placeholder="Select"
                                      v-model="tab.shiptype" style="width: 100%; border-bottom: 1px solid lightgray"
                                      :disabled="preview" filterable>
                                      <el-option v-for="option in selects.shiptypes" class="select-info"
                                        :value="option.value" :label="option.label" :key="option.value"></el-option>
                                    </el-select>
                                  </div>
                                  <div class="col-lg-12">
                                    <p style="color: #A5A5A5">
                                      IMO Number <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="tab.imonumber" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>
                                  </div>

                                  <div class="col-lg-12">
                                    <p style="color: #A5A5A5">
                                      Gross Tonnage <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="number" v-model="tab.grosstonnage" :class="{ 'custom-input': true }"
                                        min="0" :disabled="preview" />
                                    </div>
                                  </div>

                                  <div class="col-lg-12">
                                    <p style="color: #A5A5A5">
                                      Deadweight Tonnage <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="number" v-model="tab.deadweighttonnage"
                                        :class="{ 'custom-input': true }" min="0" :disabled="preview" />
                                    </div>
                                  </div>

                                  <div class="col-lg-12">
                                    <p style="color: #A5A5A5">
                                      Operator Name <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="tab.operatorname" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>
                                  </div>

                                  <div class="col-lg-12">
                                    <p style="color: #A5A5A5">
                                      Call Sign <span style="color: #EC1B23">*</span>
                                    </p>
                                    <div style="padding-right: 30px">
                                      <input type="text" v-model="tab.callsign" :class="{ 'custom-input': true }"
                                        :disabled="preview" />
                                    </div>
                                  </div>

                                  <div class="col-lg-12">
                                    <p style="color: #A5A5A5">
                                      Flag <span style="color: #EC1B23">*</span>
                                    </p>
                                    <el-select class="select-info tab select-width" placeholder="Select"
                                      v-model="tab.flag" style="width: 100%; border-bottom: 1px solid lightgray"
                                      filterable :disabled="preview">
                                      <el-option v-for="option in selects.flags" class="select-info"
                                        :value="option.value" :label="option.label" :key="option.value"></el-option>
                                    </el-select>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>

                          <div class="col-lg-6 d-flex" v-if="view !== 'add' && module == 'vessel'">
                            <card class="card-eprf">
                              <br />

                              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                                UPLOAD SHIP SUPPORT DOCUMENT
                              </p>
                              <p class="newtitle">Choose File from Your Desktop</p>
                              <p class="sub-title">
                                Please upload any existing contract for recurring job request
                              </p>
                              <div class="fileinput">
                                <label :for="tab.ship_id" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                                  Choose File
                                </label>
                                <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
                                <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                                  <circle-8></circle-8>
                                </div>

                                <input accept="application/pdf" :id="tab.ship_id" type="file" ref="shipfile" name="..."
                                  class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                  v-on:change="onFileChangeShipSupportDoc($event, tab.ship_id)" :disabled="preview" />
                              </div>
                              <div v-if="uploadload == false" style="
                height: 200px;;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                                <div v-for="(file, index) in tab.shipdoc" :key="'file_allships_' + index" class="row">
                                  <div class="col-lg-8">
                                    <a :href="file.fileurl">
                                      <base-button class="btn-link btn-primary">
                                        {{ file.filename }}
                                      </base-button>
                                    </a>
                                  </div>
                                  <div class="col-lg-4">
                                    <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                                      @click="removeShipFile(file.fileid)" :disabled="preview">
                                      Remove
                                    </base-button>
                                  </div>
                                </div>
                              </div>
                            </card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg"></div>
                    <div class="col-lg-3 text-right">
                      <base-button type="danger" v-on:click="modals.cancelModal = true">Cancel</base-button>&nbsp;

                      <base-button v-if="tab.name == 'Details' || tab.name == 'PIC'" type="primary"
                        v-on:click="handleUpdateVessel(picdetails)">Update
                      </base-button>

                      <base-button v-else type="primary" v-on:click="handleUpdateShip(tab)">Update
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </card> -->
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="module == 'land' ||
          (module == 'vessel' && view == 'add') ||
          module == 'authority'
          ">
        <div class="col-lg-6 d-flex" v-if="module != 'authority'">
          <card class="card-eprf">
            <br />
            <div class="row" style="display: flex">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  BASIC DETAILS
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <p style="color: #A5A5A5">
                  Company Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyname" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Company Reg. No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyregno" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Company Address <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyaddress" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">Company Fax Number</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyfaxno" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Company Phone Number <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyphonenumber" :class="{ 'custom-input': true }"
                    :disabled="preview" />
                  <p v-if="iscompanyphonenumber" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>
              </div>
              <div class="col-lg-6">
                <p style="color: #A5A5A5" v-if="module == 'vendor'">
                  DOE License No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px" v-if="module == 'vendor'">
                  <input type="text" v-model="doelicense" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5" v-if="module == 'vendor'">
                  DOE License Expiry <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px" v-if="module == 'vendor'">
                  <el-date-picker v-model="doeexpired" placeholder="Select" :disabled="preview"></el-date-picker>
                </div>

                <p style="color: #A5A5A5" v-if="module == 'vendor'">
                  Facility Type <span style="color: #EC1B23">*</span>
                </p>

                <el-select v-if="module == 'vendor'" class="select-info tab select-width" placeholder="Select"
                  v-model="selects.facility" style="width: 90%; border-bottom: 1px solid lightgray" filterable
                  :disabled="preview">
                  <el-option v-for="re in selects.facilitytypes" class="select-info custom-option" :value="re.value"
                    :label="re.label" :key="re.value"></el-option>
                </el-select>

                <p style="color: #A5A5A5" v-if="module == 'land' || module == 'vessel'">
                  Position <span style="color: #EC1B23">*</span>
                </p>
                <el-select v-if="module == 'land' || module == 'vessel'" class="select-info tab select-width"
                  placeholder="Select" v-model="position" style="width: 90%; border-bottom: 1px solid lightgray"
                  filterable :disabled="preview">
                  <el-option v-for="re in selects.positions" class="select-info" :value="re.value" :label="re.label"
                    :key="re.value"></el-option>
                </el-select>
              </div>
              <div class="col-lg-12">

              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="module == 'authority'">
          <card class="card-eprf">
            <br />
            <div class="row" style="display: flex">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  BASIC DETAILS
                </p>
              </div>
            </div>
            <div class="row" style="height: 520px">
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  Agency Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="agencyname" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Phone Number <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="phonenumber" :class="{ 'custom-input': true }" :disabled="preview" />
                  <p v-if="isphonenumber" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="color: #A5A5A5">Fax Number</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="faxnumber" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="module == 'vendor'">
          <card class="card-eprf">
            <br />
            <div class="row" style="display: flex">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  SW CODES
                </p>
              </div>
            </div>
            <div v-if="update" class="row">
              <div class="col-lg">
                <el-select v-if="module == 'vendor'" class="select-info tab select-width" placeholder="Select"
                  v-model="selects.sw" @change="addWasteHandle()" style="
                    width: 90%;
                    border-bottom: 1px solid lightgray;
                    color: pink !important;
                  " filterable :disabled="preview">
                  <el-option v-for="re in selects.swes" class="select-info" :value="re.value" :label="re.label"
                    :key="re.value"></el-option>
                </el-select>
              </div>
            </div>
            <br />
            <div class="col-lg-12" :style="{ height: !update ? '371px' : '330px', overflowY: 'auto' }">
              <div v-if="update" class="row">
                <div class="col-lg-5 text-center">
                  <p style="color: #707070;">CODE</p>
                </div>
                <div class="col-lg-4 text-center">
                  <p style="color: #707070;">PRICE</p>
                </div>
                <div class="col-lg-2 text-center">
                  <p style="color: #707070;"></p>
                </div>
              </div>

              <div v-if="!update" class="row">
                <div class="col-lg-6 text-center">
                  <p style="color: #707070;">CODE</p>
                </div>
                <div class="col-lg-5 text-center">
                  <p style="color: #707070;">PRICE</p>
                </div>
              </div>


              <div v-if="update" class="row" v-for="(item, index) in wastehandle"
                :key="'vendor_wastehandle_update_' + index">
                <div class="col-lg-5 text-center">
                  <p class="newtitle"
                    style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                    {{ item.waste_type_name }}
                  </p>
                </div>
                <div class="col-lg-4">
                  <div>
                    <input type="number" v-model="item.price" :class="{ 'custom-input': true }" min="0"
                      :disabled="preview" />
                  </div>
                </div>
                <div class="col-lg-2 text-center">
                  <base-button class="btn-cancel btn-icon btn-round" @click="wastehandle.splice(item.id, 1)"><i
                      class="tim-icons icon-simple-remove"></i></base-button>
                </div>
              </div>

              <div v-if="!update && wastehandle.length != 0" class="row" v-for="(item, index) in wastehandle"
                :key="'vendor_waste_not_update_' + index">
                <div class="col-lg-6 text-center">
                  <p class="newtitle"
                    style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                    {{ item.waste_type_name }}
                  </p>
                </div>
                <div class="col-lg-5 text-center">
                  <p class="newtitle" style="text-align: center">
                    {{ item.price }}
                  </p>
                </div>
              </div>

              <div v-if="!update && wastehandle.length === 0" class="row">
                <div class="col-lg-11 text-center">
                  <p class="newtitle"
                    style="text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                    No data
                  </p>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-lg"></div>
              <div v-if="update" class="col-lg-6 text-right">
                <base-button v-if="preview == false" :disabled="buttondisabled" type="primary"
                  @click="updateWasteHandle">Update
                </base-button>
              </div>
              <div v-if="!update" class="col-lg-6 text-right">
                <base-button v-if="preview == false" :disabled="buttondisabled" type="primary"
                  @click="update = !update">Edit
                </base-button>
              </div>
            </div>
          </card>
        </div>

        <div v-for="(transporter, index) in transporterdetails" :key="'transporter_detail_index_' + index"
          class="col-lg-3 d-flex" v-if="module == 'vendor'">
          <card class="card-eprf">
            <br />
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              TRANSPORTER DETAILS - {{ index + 1 }}
            </p>
            <div class="row">
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  Transporter Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="transporter.name" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  DOE No <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="transporter.doeno" :class="{ 'custom-input': true }"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Transporter Address <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="transporter.address" :class="{ 'custom-input': true }"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Transporter Phone No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="transporter.phone" :class="{ 'custom-input': true }"
                    :disabled="preview" />
                  <p v-if="istransporterphoneno" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="color: #A5A5A5">Transporter Fax</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="transporter.fax" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>
              </div>
            </div>
          </card>
        </div>

        <div v-for="(transporter, index) in transporterdetails" :key="'upload_transporter_support_doc_' + index"
          class="col-lg-3 d-flex" v-if="view !== 'add' && module == 'vendor'">
          <card class="card-eprf">
            <br />

            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              UPLOAD TRANSPORTER SUPPORT DOCUMENT - {{ index + 1 }}
            </p>
            <p class="newtitle">Choose File from Your Desktop</p>
            <p class="sub-title">
              Please upload any existing contract for recurring job request
            </p>
            <div class="fileinput">
              <label :for="transporter.transporter_id" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                Choose File
              </label>
              <div class="d-flex justify-content-center spinner" v-if="transporter.uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" :id="transporter.transporter_id" type="file" ref="transporterfile"
                name="..." class="valid" :multiple="true" aria-invalid="false" style="display: none"
                v-on:change="onFileChangeTransporterSupportDoc($event, transporter.transporter_id)"
                :disabled="preview" />
            </div>
            <div v-if="transporter.uploadload == false" style="
                                height: 200px;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
              <div v-for="(file, index) in transporter.doc" :key="'transporter.doc_' + index" class="row">
                <div class="col-lg-8">
                  <a :href="file.fileurl">
                    <base-button class="btn-link btn-primary">
                      {{ file.filename }}
                    </base-button>
                  </a>
                </div>
                <div class="col-lg-4">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                    @click="removeTransporterFile(file.fileid)" :disabled="preview">
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </card>
        </div>

        <div class="col-lg-3 d-flex" v-if="module == 'vessel'" v-for="(item, index) in ships"
          :key="'vessel_ships_' + index">
          <card class="card-eprf">
            <br />
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  SHIP DETAILS
                </p>
              </div>
              <div class="col-lg-2 text-right">
                <base-button class="btn-icon btn-round btn-cancel" @click="removeship(index)"><i
                    class="tim-icons icon-simple-remove"></i>
                </base-button>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  Ship Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.shipname" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Ship Type <span style="color: #EC1B23">*</span>
                </p>
                <el-select class="select-info tab select-width" placeholder="Select" v-model="item.shiptype"
                  style="width: 90%; border-bottom: 1px solid lightgray" :disabled="preview" filterable>
                  <el-option v-for="option in selects.shiptypes" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>

                <p style="color: #A5A5A5">
                  IMO Number <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.imonumber" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Gross Tonnage <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="number" v-model="item.grosstonnage" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Deadweight Tonnage <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="number" v-model="item.deadweighttonnage" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Operator Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.operatorname" :class="{ 'custom-input': true }"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Call Sign <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.callsign" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Flag <span style="color: #EC1B23">*</span>
                </p>
                <el-select class="select-info tab select-width" placeholder="Select" v-model="item.flag"
                  style="width: 90%; border-bottom: 1px solid lightgray" filterable :disabled="preview">
                  <el-option v-for="option in selects.flags" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>
              </div>
            </div>
          </card>
        </div>
        <!-- add ships -->
        <div class="col-lg-3 d-flex" v-if="module == 'vessel'">
          <card class="card-eprf">
            <br />
            <div class="row">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                ADD SHIP
              </p>
            </div>
            <br />
            <br />
            <div class="row">
              <div class="col-lg text-center">
                <base-button class="btn-icon-eprf btn-link" @click="addship()" :disabled="preview"><img
                    src="@/assets/img/plus.png" width="230" />
                </base-button>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="view !== 'add' && module == 'authority'">
          <card class="card-eprf">
            <br />

            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              UPLOAD AUTHORITY SUPPORT DOCUMENT
            </p>
            <p class="newtitle">Choose File from Your Desktop</p>
            <!-- <p class="sub-title">
              Please upload any existing contract for recurring job request
            </p> -->
            <div class="fileinput">
              <label for="authority-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                Choose File
              </label>
              <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
              <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="authority-upload" type="file" ref="authorityfile" name="..."
                class="valid" :multiple="true" aria-invalid="false" style="display: none" v-on:change="onInvoiceChange5"
                :disabled="preview" />
            </div>
            <div v-if="uploadload == false" style="
                height: 200px;;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
              <div v-for="(file, index) in allauthority" :key="'all_authority_file_' + index" class="row">
                <div class="col-lg-8">
                  <a :href="file.fileurl">
                    <base-button class="btn-link btn-primary">
                      {{ file.filename }}
                    </base-button>
                  </a>
                </div>
                <div class="col-lg-4">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                    @click="removeAuthorityFile(file.fileid)" :disabled="preview">
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="view !== 'add' && module != 'authority'">
          <card class="card-eprf">
            <br />

            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              UPLOAD COMPANY SUPPORT DOCUMENT
            </p>
            <p class="newtitle">Choose File from Your Desktop</p>
            <p class="sub-title">
              Please upload any existing contract for recurring job request
            </p>
            <div class="fileinput">
              <label for="invoice-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                Choose File
              </label>
              <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label>  -->
              <div class="d-flex justify-content-center spinner" v-if="compsupdoc == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="invoice-upload" type="file" ref="invoicefile" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" v-on:change="onFileChangeCompanySupportDoc"
                :disabled="preview" />
            </div>
            <div v-if="uploadload == false" style="
                height: 200px;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
              <div v-for="(file, index) in allInvoice" :key="'allinvoice_file' + index" class="row">
                <div class="col-lg-8">
                  <a :href="file.fileurl">
                    <base-button class="btn-link btn-primary">
                      {{ file.filename }}
                    </base-button>
                  </a>
                </div>
                <div class="col-lg-4">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px" @click="removecompanyfile(file.fileid)"
                    :disabled="preview">
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </card>
        </div>

        <div class="col-lg-3 d-flex" v-if="view !== 'add' && module == 'vendor'">
          <card class="card-eprf">
            <br />

            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              UPLOAD DOE SUPPORT DOCUMENT
            </p>
            <p class="newtitle">Choose File from Your Desktop</p>
            <p class="sub-title">
              Please upload any existing contract for recurring job request
            </p>
            <div class="fileinput">
              <label for="doe-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                Choose File
              </label>
              <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
              <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="doe-upload" type="file" ref="doefile" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" v-on:change="onInvoiceChange4"
                :disabled="preview" />
            </div>
            <div v-if="uploadload == false" style="
                height: 200px;;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
              <div v-for="(file, index) in alldoe" :key="'all_doe_file' + index" class="row">
                <div class="col-lg-8">
                  <a :href="file.fileurl">
                    <base-button class="btn-link btn-primary">
                      {{ file.filename }}
                    </base-button>
                  </a>
                </div>
                <div class="col-lg-4">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px" @click="removeFile(file.fileid)"
                    :disabled="preview">
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="view !== 'add' && module == 'vessel'">
          <card class="card-eprf">
            <br />

            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              UPLOAD SHIP SUPPORT DOCUMENT
            </p>
            <p class="newtitle">Choose File from Your Desktop</p>
            <p class="sub-title">
              Please upload any existing contract for recurring job request
            </p>
            <div class="fileinput">
              <label for="ship-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                Choose File
              </label>
              <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
              <div class="d-flex justify-content-center spinner" v-if="shipdoc == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="ship-upload" type="file" ref="shipfile" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" v-on:change="onFileChangeShipSupportDoc"
                :disabled="preview" />
            </div>
            <div v-if="shipdoc == false" style="
                height: 200px;;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
              <div v-for="(file, index) in allships" :key="'all_ships_file_' + index" class="row">
                <div class="col-lg-8">
                  <a :href="file.fileurl">
                    <base-button class="btn-link btn-primary">
                      {{ file.filename }}
                    </base-button>
                  </a>
                </div>
                <div class="col-lg-4">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px" @click="removeShipFile(file.fileid)"
                    :disabled="preview">
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </card>
        </div>

        <div class="col-lg-3 d-flex" v-for="(item, index) in picdetails" :key="'pic_detail_item_' + index">
          <card class="card-eprf">
            <br />
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  PIC DETAILS - {{ index + 1 }}
                </p>
              </div>
              <div class="col-lg-2 text-right">
                <base-button class="btn-cancel btn-icon btn-round" @click="removepic(index)"><i
                    class="tim-icons icon-simple-remove"></i></base-button>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  User name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.username" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  User Email <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.useremail" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  User Phone Number <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.userphonenumber" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                  <p v-if="item.userphonenumber.length <= 7" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="color: #A5A5A5">User Fax Number</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.userfaxnumber" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>
                <p style="color: #A5A5A5" v-if="view == 'add' || item.flag == 'new'">
                  Password <span style="color: #EC1B23">*</span>
                </p>
                <div class="col-lg-12">
                  <div class="row" v-if="view == 'add' || item.flag == 'new'">
                    <input class="col-lg" v-if="item.showPassword1" type="text" v-model="item.password"
                      :class="{ 'custom-input': true }" />
                    <input class="col-lg" v-else type="password" v-model="item.password" @focus="short = true"
                      :class="{ 'custom-input': true }" />
                    <button class="custom-button" @click="toggleShoww1(index)">
                      <span class="icon is-small is-right">
                        <i class="fas" :class="{
          'fa-eye-slash': item.showPassword1,
          'fa-eye': !item.showPassword1,
        }"></i>
                      </span>
                    </button>
                    <!-- </div> -->
                    <!-- <div style="padding-left: 330px; display: flex"> -->
                    <el-tooltip class="col-lg-1" effect="light" :open-delay="300" placement="top">
                      <template v-slot:content>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!item.alphanumeric" class="fas fa-times-circle red-circle"></i>
                            <i v-if="item.alphanumeric" class="fas fa-check-circle green-circle"></i>
                            At least 8 alphanumeric characters
                          </p>
                          &nbsp;&nbsp;
                        </div>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!item.upperlower" class="fas fa-times-circle red-circle"></i>
                            <i v-if="item.upperlower" class="fas fa-check-circle green-circle"></i>
                            Must include uppercase and lowercase
                          </p>
                        </div>
                        <div style="display: flex">
                          <p style="
                            font-style: italic;
                            font-size: 11px;
                            color: #5a5a5a;
                          ">
                            <i v-if="!item.special" class="fas fa-times-circle red-circle"></i>
                            <i v-if="item.special" class="fas fa-check-circle green-circle"></i>
                            Must include symbol (e.g. !@#$%^&*)
                          </p>
                        </div>
                      </template>
                      <base-button type="link">
                        <i class="tim-icons icon-alert-circle-exc"></i>
                      </base-button>
                    </el-tooltip>
                  </div>
                </div>

                <p style="color: #A5A5A5" v-if="view == 'add' || item.flag == 'new'">
                  Confirm Password <span style="color: #EC1B23">*</span>
                </p>

                <div style="padding-right: 30px; display: flex" v-if="view == 'add' || item.flag == 'new'">
                  <input v-if="item.showPassword" type="text" v-model="item.confirmpassword"
                    @focus="item.showPasswordMismatch = true" :class="{ 'custom-input': true }" />
                  <input v-else type="password" v-model="item.confirmpassword" :class="{ 'custom-input': true }" />
                  <button class="custom-button" @click="toggleShoww(index)">
                    <span class="icon is-small is-right">
                      <i class="fas" :class="{
          'fa-eye-slash': item.showPassword,
          'fa-eye': !item.showPassword,
        }"></i>
                    </span>
                  </button>
                </div>

                <div style="display: flex; height: 30px" v-if="view == 'add' || item.flag == 'new'">
                  <p v-if="item.showPasswordMismatch &&
          item.confirmpassword !== item.password
          " style="font-size: 11px; color: #ea2127">
                    {{ item.pwdmessage }}
                  </p>
                </div>
              </div>
            </div>
          </card>
        </div>

        <div class="col-lg-3 d-flex">
          <card class="card-eprf">
            <br />
            <div class="row">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                ADD PIC
              </p>
            </div>
            <br />
            <br />
            <div class="row">
              <div class="col-lg text-center">
                <base-button class="btn-icon-eprf btn-link" @click="addpic()" :disabled="preview"><img
                    src="@/assets/img/plus.png" width="230" />
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div v-if="module == 'vessel'" class="col-lg-12">
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <base-button type="danger" v-on:click="modals.cancelModal = true">Cancel</base-button>&nbsp;

            <base-button type="primary" v-on:click="handleAddVessel(picdetails)">Done
            </base-button>
          </div>
        </div>
      </div>

      <div v-if="module != 'vendor' && module != 'vessel'" class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button type="danger" v-on:click="modals.cancelModal = true">Cancel</base-button>&nbsp;

          <base-button v-if="preview == false" :disabled="buttondisabled" type="primary" v-on:click="handleDone()">Done
          </base-button>
        </div>
      </div>

      <modal :show.sync="modals.editPIC" :preventClose="true">
        <div class="modal-header" style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #358CCB;
          ">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg text-left justify-content-center align-items-center">
                <h4 class="mb-0">EDIT PIC</h4>
              </div>
              <div class="col-lg-3 d-flex justify-content-center align-items-center">
                <base-button class="btn-icon btn-cancel btn-round btn-sm" style="margin-top: -28px;">
                  <i style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    " class="tim-icons icon-simple-remove" @click="modals.editPIC = false"></i>
                </base-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <p style="color: #A5A5A5">
            User name <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="text" v-model="newpicname" :class="{ 'custom-input': true }" :disabled="preview" />
          <!-- </div> -->

          <p style="color: #A5A5A5">
            User Email <span style="color: #EC1B23">*</span>
          </p>
          <input type="text" v-model="newpicemail" :class="{ 'custom-input': true }" :disabled="preview" />

          <p style="color: #A5A5A5">
            User Phone Number <span style="color: #EC1B23">*</span>
          </p>
          <input type="text" v-model="newpicphoneno" :class="{ 'custom-input': true }" :disabled="preview" />

          <p style="color: #A5A5A5">
            User Fax Number
          </p>
          <input type="text" v-model="newpicfaxno" :class="{ 'custom-input': true }" :disabled="preview" />
          <!-- </div> -->


          <br /><br /><br />
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-8 text-right">
              <base-button type="primary" :disabled="newpicname === '' || newpicemail === '' || newpicphoneno === ''"
                @click="doneeditpic()">Done
              </base-button>
            </div>
          </div>
        </div>
      </modal>

      <modal :show.sync="modals.addPIC" :preventClose="true">
        <div class="modal-header" style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #358CCB;
          ">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg text-left justify-content-center align-items-center">
                <h4 class="mb-0">NEW PIC</h4>
              </div>
              <div class="col-lg-3 d-flex justify-content-center align-items-center">
                <base-button class="btn-icon btn-cancel btn-round btn-sm" style="margin-top: -28px;">
                  <i style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    " class="tim-icons icon-simple-remove" @click="modals.addPIC = false"></i>
                </base-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <p style="color: #A5A5A5">
            User name <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="text" v-model="newpicname" :class="{ 'custom-input': true }" :disabled="preview" />
          <!-- </div> -->

          <p style="color: #A5A5A5">
            User Email <span style="color: #EC1B23">*</span>
          </p>
          <input type="text" v-model="newpicemail" :class="{ 'custom-input': true }" :disabled="preview" />

          <p style="color: #A5A5A5">
            User Phone Number <span style="color: #EC1B23">*</span>
          </p>
          <input type="text" v-model="newpicphoneno" :class="{ 'custom-input': true }" :disabled="preview" />

          <p style="color: #A5A5A5">
            User Fax Number
          </p>
          <input type="text" v-model="newpicfaxno" :class="{ 'custom-input': true }" :disabled="preview" />
          <!-- </div> -->


          <br /><br /><br />
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-8 text-right">
              <base-button type="primary" :disabled="newpicname === '' || newpicemail === '' || newpicphoneno === ''"
                @click="addpic()">Add PIC
              </base-button>
            </div>
          </div>
        </div>
      </modal>

      <modal :show.sync="modals.addShip" :preventClose="true">
        <div class="modal-header" style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #358CCB;
          ">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg text-left justify-content-center align-items-center">
                <h4 class="mb-0">NEW SHIP</h4>
              </div>
              <div class="col-lg-3 d-flex justify-content-center align-items-center">
                <base-button class="btn-icon btn-cancel btn-round btn-sm" style="margin-top: -28px;">
                  <i style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    " class="tim-icons icon-simple-remove" @click="modals.addShip = false"></i>
                </base-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <p style="color: #A5A5A5">
            Ship Name <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="text" v-model="newshipname" :class="{ 'custom-input': true }" :disabled="preview" />
          <!-- </div> -->

          <p style="color: #A5A5A5">
            Ship Type <span style="color: #EC1B23">*</span>
          </p>
          <el-select class="select-info tab select-width" placeholder="Select" v-model="newshiptype"
            style="width: 100%; border-bottom: 1px solid lightgray" :disabled="preview" filterable>
            <el-option v-for="option in selects.shiptypes" class="select-info" :value="option.value"
              :label="option.label" :key="option.value"></el-option>
          </el-select>

          <p style="color: #A5A5A5">
            IMO Number <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="text" v-model="newimo" :class="{ 'custom-input': true }" :disabled="preview" />
          <!-- </div> -->

          <p style="color: #A5A5A5">
            Gross Tonnage <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="number" v-model="newgross" :class="{ 'custom-input': true }" min="0" :disabled="preview" />
          <!-- </div> -->

          <p style="color: #A5A5A5">
            Deadweight Tonnage <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="number" v-model="newtonnage" :class="{ 'custom-input': true }" min="0" :disabled="preview" />
          <!-- </div> -->

          <p style="color: #A5A5A5">
            Operator Name <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="text" v-model="newoperation" :class="{ 'custom-input': true }" :disabled="preview" />
          <!-- </div> -->

          <p style="color: #A5A5A5">
            Call Sign <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="text" v-model="newcallsign" :class="{ 'custom-input': true }" :disabled="preview" />
          <!-- </div> -->

          <p style="color: #A5A5A5">
            Flag <span style="color: #EC1B23">*</span>
          </p>
          <el-select class="select-info tab select-width" placeholder="Select" v-model="newflag"
            style="width: 100%; border-bottom: 1px solid lightgray" filterable :disabled="preview">
            ∫ <el-option v-for="option in selects.flags" class="select-info" :value="option.value" :label="option.label"
              :key="option.value"></el-option>
          </el-select>

          <br /><br /><br />
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-8 text-right">
              <base-button type="primary" @click="addnewship()">Add Ship
              </base-button>
            </div>
          </div>
        </div>
      </modal>

      <modal :show.sync="modals.addTransporter" :preventClose="true">
        <div class="modal-header" style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #358CCB;
          ">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg text-left justify-content-center align-items-center">
                <h4 class="mb-0">NEW TRANSPORTER</h4>
              </div>
              <div class="col-lg-3 d-flex justify-content-center align-items-center">
                <base-button class="btn-icon btn-cancel btn-round btn-sm" style="margin-top: -28px;">
                  <i style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    " class="tim-icons icon-simple-remove" @click="modals.addTransporter = false"></i>
                </base-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <br />
          <p style="color: #A5A5A5">
            Transporter Name <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="text" v-model="newtransname" :class="{ 'custom-input': true }" :disabled="preview" />
          <!-- </div> -->

          <p style="color: #A5A5A5">
            DOE No <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="text" v-model="newtransdoeno" :class="{ 'custom-input': true }" :disabled="preview" />
          <!-- </div> -->

          <p style="color: #A5A5A5">
            Transporter Address <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="text" v-model="newtransaddress" :class="{ 'custom-input': true }" :disabled="preview" />
          <!-- </div> -->

          <p style="color: #A5A5A5">
            Transporter Phone No. <span style="color: #EC1B23">*</span>
          </p>
          <!-- <div style="padding-right: 30px"> -->
          <input type="text" v-model="newtransphoneno" :class="{ 'custom-input': true }" :disabled="preview" />
          <p v-if="istransporterphoneno" style="font-size: 12px; color: #EC1B23">
            The length of the phone number is insufficient.
          </p>
          <!-- </div> -->

          <p style="color: #A5A5A5">Transporter Fax</p>
          <div style="padding-right: 30px">
            <input type="text" v-model="newtransfaxno" :class="{ 'custom-input': true }" :disabled="preview" />
          </div>

          <br /><br /><br />
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-8 text-right">
              <base-button type="primary" @click="addtransporter()">Add Transporter
              </base-button>
            </div>
          </div>
        </div>
      </modal>

      <modal :show.sync="modals.infoModal" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #15b0cf;
          ">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-info"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Info!
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">{{ message }}</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center" style="margin-bottom: 30px">
            <base-button type="primary" v-on:click="modals.infoModal = false">Ok</base-button>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.successModal2" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #15cf79;
          ">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-check"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Successfull!
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">{{ message }}</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center" style="margin-bottom: 30px">
            <base-button type="primary" v-on:click="modals.successModal2 = false">Continue</base-button>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.cancelModal" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #cf6a15;
          ">
          <div class="row">
            <div class="col-lg"></div>

            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-question"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Are you sure?
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">All changes will not be updated.</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-6 text-right" style="margin-bottom: 30px">
            <base-button type="danger" v-on:click="modals.cancelModal = false">Cancel</base-button>
          </div>
          <div class="col-lg-6 text-left" style="margin-bottom: 30px">
            <base-button type="primary" v-on:click="redirect()">Continue</base-button>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.failedModal" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #EC1B23;
            text-align: center;
          ">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-exclamation"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Error
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">{{ message }}</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <p style="color: #A5A5A5; margin-top: 20px">
              Click 'Retry' to go back.
            </p>

            <base-button type="danger" v-on:click="getBack()">Exit</base-button>&nbsp;
            <base-button type="primary" v-on:click="closeFailedModal()">Retry</base-button>
          </div>
        </div>
      </modal>

      <StatusModal :show.sync="modals.doneaddPIC" :message="`PIC successfully added!`" :title="modal.successTitle" />
      <StatusModal :show.sync="modals.doneeditPIC" :message="`PIC successfully edited!`" :title="modal.successTitle" />
      <StatusModal :show.sync="modals.doneremovePIC" :message="`PIC successfully removed!`"
        :title="modal.successTitle" />


      <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />
      <StatusModal :show.sync="modals.successUploadModal" :message="modal.success" :title="modal.successTitle" />
      <StatusModal :show.sync="modals.removeModal" :message="modal.remove" :title="modal.removeTitle" />
      <StatusModal :show.sync="modals.removeFailedModal" :message="modal.removeFailed" :title="modal.removeTitle" />

      <StatusModal :show.sync="modals.deleteModalTransporter" :message="modal.deleteItemSuccessTransporter"
        :title="modal.deleteTitleTransporter" />
      <StatusModal :show.sync="modals.deleteModalTransporterFailed" :message="modal.deleteItemFailedTransporter"
        :title="modal.deleteTitleTransporter" />

      <StatusModal :show.sync="modals.deleteModalShip" :message="modal.deleteItemSuccessShip"
        :title="modal.deleteTitleShip" />
      <StatusModal :show.sync="modals.deleteModalShipFailed" :message="modal.deleteItemFailedShip"
        :title="modal.deleteTitleShip" />


    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Alert, DatePicker, Tooltip } from "element-ui";
import swal from "sweetalert2";
import Card from "../../../components/Cards/Card.vue";
import { Select, Option } from "element-ui";
import { colors } from "../../../components/colors.js";
import { Modal } from "../../../../src/components";
import { debounce } from "src/util/debounce";
import moment from "moment";
import { modal } from "src/components/variable.js";
import StatusModal from 'src/components/StatusModal.vue';
import { getStorage } from "../../../util/storage";
import { Circle8 } from "vue-loading-spinner";

export default {
  name: "AddUser",

  components: {
    Card,
    Modal,
    [Tooltip.name]: Tooltip,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    StatusModal,
    Circle8,

  },

  data() {
    return {
      image: null,
      loadingPercentage: 0,
      load: false,

      newshipname: '',
      newshiptype: 0,
      newimo: '',
      newgross: 0,
      newtonnage: 0,
      newoperation: '',
      newcallsign: '',
      newflag: 0,

      picindex: 0,
      newpicname: '',
      newpicemail: '',
      newpicphoneno: '',
      newpicfaxno: '',

      newtransname: '',
      newtransdoeno: '',
      newtransaddress: '',
      newtransphoneno: '',
      newtransfaxno: '',
      newtransdocs: [],

      newsupportdoc: [],
      newdoedoc: [],

      newdriver: [],
      newtrucks: [],

      newname: '',
      newnric: '',
      newtruck: '',
      details: false,
      condition: true,
      activeTab: 0,
      tabs: [
        {
          name: "AFES", content: "Content for Tab 1", total: 0,
          doeno: '',
          address: '',
          phoneno: '',
          faxno: '',

          // original response
          doe_no: '',
          transporter_address: '',
          transporter_support_documents: [{
            transporter_document_id: 0,
            url: "",
            meta: { filename: "", filesize: 0 },
            created_at: "",
          }],
          transporter_doe_support_documents: [{
            transporter_doe_document_id: 0,
            url: "",
            meta: { filename: "", filesize: 0 },
            doe_expired_at: "",
            created_at: "",
          }],
          transporter_fax: '',
          transporter_id: 0,
          transporter_name: "",
          transporter_phone: "",

          drivers: [{
            driver_id: 0,
            driver_name: "",
            driver_nric: "",
          }],
          vehicles: [{
            vehicle_id: 0,
            vehicle_reg_num: "",
          }],
        },
      ],
      accessid: 0,

      vesseltabs: [
        {
          ship_id: 0,
          shipname: '',
          shiptype: 0,
          ship_type_name: '',
          imonumber: '',
          grosstonnage: 0,
          deadweighttonnage: 0,
          operatorname: '',
          callsign: '',
          flag: 0,
          shipdoc: [],

          name: "Vessel",
          content: "Content for Tab 1",
        },
      ],

      selectedWasteTypeId: '',
      drivers: [{
        id: 0,
        name: "",
        nric: "",
      }],
      update: false,
      alphanumeric: false,
      upperlower: false,
      special: false,
      alphanumeric2: false,
      upperlower2: false,
      special2: false,
      errmsg: "",
      positionid: 0,
      preview: "",
      position: "",
      role: "",
      module: "",
      view: "add",
      buttondisabled: false,
      email_unique: "",
      colors: colors,
      showPassword: false,
      showPassword1: false,

      short: "",
      short1: "",
      showPasswordMismatch: "",

      // afes
      fullname: "",
      password: "",
      confirmpassword: "",
      isphoneno: "",
      phoneno: "",
      email: "",
      staffID: "",
      remarks: "",

      // land
      companyid: 0,
      companyname: "",
      companyregno: "",
      companyaddress: "",
      companyfaxno: "",
      iscompanyphonenumber: false,
      companyphonenumber: "",
      allInvoice: [],
      allships: [],
      alltransporter: [],
      alldoe: [],
      allauthority: [],
      picdata: [
        {
          username: 'nad',
          useremail: 'nad@vectolabs.com',
          phoneno: '123',
          faxno: '999',
        },
        {
          username: 'nad1',
          useremail: 'nad1@vectolabs.com',
          phoneno: '1234',
          faxno: '9999',
        }
      ],
      picdetails: [
        {
          alphanumeric: false,
          upperlower: false,
          special: false,
          username: "",
          useremail: "",
          userphonenumber: "",
          userfaxnumber: "",
          password: "",
          confirmpassword: "",
          showPassword: false,
          showPassword1: false,
          showPasswordMismatch: false,
          pwdmessage: "Password mismatch.",
        },
      ],

      // vessel
      ships: [
        {
          shipname: "",
          shiptype: "",
          imonumber: "",
          grosstonnage: "",
          deadweighttonnage: "",
          operatorname: "",
          callsign: "",
          flag: "",
        },
      ],

      // vendor
      transportername: "",
      doeno: "",
      transporteraddress: "",
      transporterphoneno: "",
      istransporterphoneno: false,
      transporterfax: "",
      transporterdetails: [
        {
          name: '',
          doeno: '',
          address: '',
          phoneno: '',
          faxno: '',

          // original response
          doe_no: '',
          transporter_address: '',
          transporter_doe_support_documents: [{
            transporter_doe_document_id: 0,
            url: "",
            meta: { filename: "", filesize: 0 },
            doe_expired_at: "",
            created_at: "",
          }],
          transporter_fax: '',
          transporter_id: 0,
          transporter_name: "",
          transporter_phone: "",
          transporter_support_documents: [{
            transporter_document_id: 0,
            url: "",
            meta: { filename: "", filesize: 0 },
            created_at: "",
          }],
          drivers: [{
            driver_id: 0,
            driver_name: "",
            driver_nric: "",
          }],
          vehicles: [{
            vehicle_id: 0,
            vehicle_reg_num: "",
          }],
        }
      ],
      driverdetails: [
        {
          drivername: "",
          nric: "",
        },
      ],
      truckdetails: [
        {
          id: "",
          registrationno: "",
        },
      ],
      doelicense: "",
      doeexpired: "",
      facilitytype: "",

      // authority
      agencyname: "",
      isphonenumber: false,
      phonenumber: "",
      faxnumber: "",

      modals: {
        deleteModalTransporter: false,
        deleteModalTransporterFailed: false,
        deleteModalShip: false,
        deleteModalShipFailed: false,
        addShip: false,
        addPIC: false,
        editPIC: false,
        doneeditPIC: false,
        doneaddPIC: false,
        doneremovePIC: false,
        addTransporter: false,
        successModal: false,
        successModal2: false,
        failedModal: false,
        failedModal2: false,
        successUploadModal: false,

        cancelModal: false,
        removeModal: false,
        removeFailedModal: false,
        infoModal: false,
        warningModal: false,
      },
      modal: modal,
      message: "",
      selects: {
        usertype: "",
        usertypes: [
          { value: 1, label: "AFES - Admin Main" },
          { value: 2, label: "AFES - Admin PIC" },
          { value: 3, label: "AFES - Operation" },
          { value: 4, label: "AFES - Management" },
          { value: 5, label: "Customer - Land Generator" },
          { value: 6, label: "Customer - Vessel Generator" },
          { value: 7, label: "Vendor" },
          { value: 8, label: "Authorities" },
        ],
        servicelocation: "",
        servicelocations: [],
        shiptypes: [],
        flags: [],
        facility: '',
        facilitytypes: [
          { label: "", value: 0 }
        ],
        positions: [],
        sw: [],
        swes: [],
      },
      compsupdoc: false,
      shipdoc: false,
      uploadload: false,
      docload: false,
      wastehandle: [
        {
          waste_type_id: 0,
          sell_price: 0,
          buy_price: 0,
          waste_type_name: '',
        }
      ],
    };
  },
  methods: {
    removeImages(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/profile/digital-signature")
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                swal({
                  title: `Success!`,
                  text: 'File successfully deleted.',
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-primary btn-fill",
                  type: "success",
                });
                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
                // this.getDetail();
              }
            });
        }
      });
    },
    onImagesChange(e) {
      console.log("tengah tekan sini ha");
      this.load = true;
      this.loadingPercentage = 0;

      const input = e.target;
      const file = input.files[0];

      if (!file) {
        this.load = false;
        return;
      }

      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        const aspectRatio = img.width / img.height;
        URL.revokeObjectURL(objectUrl); // Free up memory

        if ((img.width <= 300 && img.height <= 150) || (img.width / img.height === 2)) {
          const formData = new FormData();
          formData.append("image", file);

          const config = {
            headers: {
              Authorization: `Bearer ${getStorage("token")}`,
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              this.loadingPercentage = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            },
          };

          this.$http
            .post(":10001/api/v1/profile/digital-signature", formData, config)
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log("response", response);
                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);

                this.load = false;
              }
            })
            .catch(() => {
              this.load = false;
            });
        } else {
          this.load = false;
          swal({
            title: `Failed!`,
            text: 'Please upload image with size 300x150 (2:1).',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-primary btn-fill",
            type: "error",
          });
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(objectUrl); // Free up memory
        this.load = false;
        alert("Failed to load the image.");
      };

      img.src = objectUrl;
    }
    ,
    addWasteHandle() {
      let obj = {
        id: this.wastehandle.length,
        waste_type_id: this.selects.sw,
        sell_price: 0,
        buy_price: 0,
        waste_type_name: this.selectedLabel,
      };

      console.log(this.selectedLabel);

      this.wastehandle.push(obj);
    },

    updateWasteHandle() {
      let obj = [];

      for (var i = 0; i < this.wastehandle.length; i++) {
        let objj = {
          waste_type_id: this.wastehandle[i].waste_type_id,
          sell_price: typeof this.wastehandle[i].sell_price !== 'number' ? parseInt(this.wastehandle[i].sell_price) : this.wastehandle[i].sell_price,
          buy_price: typeof this.wastehandle[i].buy_price !== 'number' ? parseInt(this.wastehandle[i].buy_price) : this.wastehandle[i].buy_price,
        }
        obj.push(objj);
      }

      console.log(obj);
      this.$http
        .put(
          ":10001/api/v1/user-management/update/vendor/" + this.view + "/waste_handle",
          obj
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Waste handle updated.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
                this.update = !this.update;
              }
            });
          } else {
            console.log("quote not approve", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Waste handle failed to update.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });

    },
    checkPassword(value, index) {
      const alphanumericPattern =
        /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      const hasUppercase = /[A-Z]/.test(value);
      const hasLowercase = /[a-z]/.test(value);
      const hasSpecialChar = /[!@#$%^&*]/.test(value);

      if (alphanumericPattern.test(value)) {
        this.picdetails[index].alphanumeric = true;
      } else {
        this.picdetails[index].alphanumeric = false;
      }

      if (hasUppercase && hasLowercase) {
        this.picdetails[index].upperlower = true;
      } else {
        this.picdetails[index].upperlower = false;
      }

      if (hasSpecialChar) {
        this.picdetails[index].special = true;
      } else {
        this.picdetails[index].special = false;
      }

      if (
        this.picdetails[index].showPasswordMismatch &&
        this.picdetails[index].confirmpassword !== value
      ) {
        this.picdetails[index].pwdmessage = "Passwords mismatch.";
      } else {
        this.picdetails[index].pwdmessage = "";
      }

      console.log(this.message);
    },

    checkPassword2(value) {
      const alphanumericPattern =
        /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      const hasUppercase = /[A-Z]/.test(value);
      const hasLowercase = /[a-z]/.test(value);
      const hasSpecialChar = /[!@#$%^&*]/.test(value);

      if (alphanumericPattern.test(value)) {
        this.alphanumeric = true;
      } else if (!alphanumericPattern.test(value)) {
        this.alphanumeric = false;
      }

      if (hasUppercase && hasLowercase) {
        this.upperlower = true;
      } else if (!hasUppercase || !hasLowercase) {
        this.upperlower = false;
      }

      if (hasSpecialChar) {
        this.special = true;
      } else if (!hasSpecialChar) {
        this.special = false;
      }

      console.log(this.message);
    },

    removeship(index) {
      this.ships.splice(index, 1);
    },
    closeModal() {
      this.modals.successModal2 = false;
      this.$router.push("/Users");
    },
    removetruck(tabs, index) {
      console.log(index);
      if (index >= 0 && index < tabs.length) {
        tabs.splice(index, 1);
      }
    },
    removepic(index) {
      console.log(index);
      this.picdetails.splice(index, 1);
    },
    editpic(index, name, email, phoneno, faxno) {

      this.picindex = index;
      this.newpicname = name;
      this.newpicemail = email;
      this.newpicphoneno = phoneno;
      this.newpicfaxno = faxno;

      this.modals.editPIC = true;

    },
    doneeditpic() {
      console.log('index dia', this.picindex)
      if (this.view != 'add') {
        this.$set(this.picdetails, this.picindex, {
          username: this.newpicname,
          useremail: this.newpicemail,
          userphonenumber: this.newpicphoneno,
          userfaxnumber: this.newpicfaxno,
        });

        this.picindex = 0;
        this.newpicname = '';
        this.newpicemail = '';
        this.newpicphoneno = '';
        this.newpicfaxno = '';

        this.modals.editPIC = false;
        this.modals.doneeditPIC = true;

        console.log('data dia', this.picdetails)
      }
    },
    removepicc(index) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.picdetails.splice(index, 1);
          this.modals.doneremovePIC = true;

        }
      });
    },
    removedriver(tabs, index) {
      console.log(index);
      if (index >= 0 && index < tabs.length) {
        tabs.splice(index, 1);
      }
    },
    redirect() {
      this.modals.successModal2 = false;
      this.$router.push("/Users");
    },
    getSW() {
      this.selects.swes = [];

      this.$http.get(":10001/api/v1/setting/wastes").then((res) => {
        if (res.error) {
          console.error(res.message)

          throw new Error("Waste API errors")

        }

        this.selects.swes = res.message.map(waste => {
          return { label: waste.code, value: waste.waste_type_id }
        })
      })
        .catch(err => console.error(err))
        .finally(() => console.log('getSW done'))
    },

    getFlag() {
      this.selects.flags = [];

      this.$http.get(":10001/api/v1/setting/flags").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].country_name,
              value: response[i].flag_id,
            };
            this.selects.flags.push(obj);
          }
        }
      });
    },
    getShipType() {
      this.selects.shiptypes = [];

      this.$http.get(":10001/api/v1/setting/ship_types").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].ship_type_name,
              value: response[i].ship_type_id,
            };
            this.selects.shiptypes.push(obj);
          }
        }
      });
    },
    getFacilityType() {
      this.selects.facilitytypes = [];
      const acceptableResponseType = ["array", "object"]
      this.$http.get(":10001/api/v1/setting/facilities")
        .then((res) => {
          if (res.error) {
            console.error(res.message)
            throw new Error("Facility API: errors")
          } else if (!acceptableResponseType.includes(typeof res.message)) {
            console.error(`type: ${typeof res.message}, content: ${res.message}`)
            throw new Error("Facility API: invalid type response")
          }

          for (const [index, facility] of res.message.entries()) {
            if (this.selects.facilitytypes.some(e => e.value === facility.facility_type_id)) {
              console.log(`duplicate facility index: ${index}, content: ${facility.facility_type_id}`)
              continue
            }
            this.selects.facilitytypes.push({ value: facility.facility_type_id, label: facility.facility_type_name })
          }
        })
        .catch(err => console.error(err))

      if (this.facilitytype === "") return
      const selectedIndex = this.selects.facilitytypes.findIndex(
        (facility) => facility.value === this.facilitytype
      );

      this.selects.facility = this.selects.facilitytypes[selectedIndex].value;
    },
    removeAuthorityFile(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/user-management/" +
              this.module +
              "/" +
              this.view +
              "/authority_support_document/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal2 = true;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },
    deleteship(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        console.log('ship id', id);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/user-management/update/" + this.module + "/" + this.view + "/ship/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.deleteModalShip = true;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.deleteModalShipFailed = true;
              }
            });
        }
      });
    },
    deletetransporter(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/user-management/update/" +
              this.module +
              "/" +
              this.view +
              "/transporter/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.deleteModalTransporter = true;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.deleteModalTransporterFailed = true;
              }
            });
        }
      });
    },
    removeTransporterFile(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/user-management/" +
              this.module +
              "/" +
              this.view +
              "/transporter_support_document/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },
    removeFile(id, type) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          console.log(this.newtransdocs)

          this.newtransdocs = this.newtransdocs.filter(function (doc) {
            return doc.document_id !== id;
          });

          this.modals.removeModal = true;
        }
      });
    },
    removeFile1(id, type) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {

          this.newsupportdoc = this.newsupportdoc.filter(function (doc) {
            return doc.document_id !== id;
          });

          this.modals.removeModal = true;
        }

      });
    },
    removeFile2(id, type) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);

        if (result.value == true) {

          this.newdoedoc = this.newdoedoc.filter(function (doc) {
            return doc.document_id !== id;
          });

          this.modals.removeModal = true;
        }

      });
    },
    removeShipFile(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/user-management/" +
              this.module +
              "/" +
              this.view +
              "/ship_support_document/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    removecompanyfile(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/user-management/" +
              this.module +
              "/" +
              this.view +
              "/company_support_document/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    onFileChangeDoeDoc(event) {
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.doctitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.uploadload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("document", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/user-management/" +
              this.module +
              "/" +
              this.view +
              "/doe_support_document",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";
          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.uploadload = false;
            // this.buttondisabled = false;
          });
      } else {
        this.doctitle = "";
      }
    },

    removeDoeDoc(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/user-management/" +
              this.module +
              "/" +
              this.view +
              "/doe_support_document/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    onFileChange(event, type) {
      this.docload = true;

      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.doctitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.quoload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("document", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/upload/" + type,
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.newtransdocs.push(
                  {
                    document_id: response.document_id,
                    filename: response.filename,
                    url: response.url,
                  }
                );

                console.log(this.newtransdocs)

                setTimeout(() => {
                  // this.getUserDetail(this.view, this.module);
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.docload = false;
            // this.buttondisabled = false;
          });
      } else {
        this.doctitle = "";
      }
    },

    onFileChange1(event, type) {
      this.compsupdoc = true;

      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.doctitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.quoload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("document", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/upload/" + type,
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                this.newsupportdoc.push(
                  {
                    document_id: response.document_id,
                    filename: response.filename,
                    url: response.url,
                  }
                );

                setTimeout(() => {
                  // this.getUserDetail(this.view, this.module);
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.compsupdoc = false;

            // this.buttondisabled = false;
          });
      } else {
        this.doctitle = "";
      }
    },

    onFileChange2(event, type) {
      this.uploadload = true;

      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.doctitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.quoload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("document", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/upload/" + type,
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                this.newdoedoc.push(
                  {
                    document_id: response.document_id,
                    filename: response.filename,
                    url: response.url,
                  }
                );

                setTimeout(() => {
                  // this.getUserDetail(this.view, this.module);
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.uploadload = false;
            // this.buttondisabled = false;
          });
      } else {
        this.doctitle = "";
      }
    },

    onFileChangeTransporterSupportDoc(event, transporter) {
      console.log('transid', transporter);
      this.compsupdoc = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.doctitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.quoload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/user-management/update/" +
              this.module +
              "/" +
              this.view +
              "/transporter/" +
              transporter +
              "/support-document",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.compsupdoc = false;
            // this.buttondisabled = false;
          });
      } else {
        this.doctitle = "";
      }
    },

    onFileChangeShipSupportDoc(event, shipid) {
      console.log('ship id', shipid);
      this.shipdoc = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.doctitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.quoload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/user-management/update/" +
              this.module +
              "/" +
              this.view +
              "/ship/" + shipid +
              "/ship-support-document",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.shipdoc = false;
            // this.buttondisabled = false;
          });
      } else {
        this.doctitle = "";
      }
    },

    onFileChangeCompanySupportDoc(event) {
      this.compsupdoc = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.doctitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.quoload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("document", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/user-management/" +
              this.module +
              "/" +
              this.view +
              "/company_support_document",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.compsupdoc = false;
            // this.buttondisabled = false;
          });
      } else {
        this.doctitle = "";
      }
    },

    onInvoiceChange() {
      let data = this.$refs.invoicefile.files[0];

      const formData = new FormData();
      formData.append("document", data);

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      // if (this.module == "land") {
      let url =
        ":10001/api/v1/user-management/" +
        this.module +
        "/" +
        this.view +
        "/company_support_document";
      // }

      console.log(url);
      this.$http
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal2 = true;
            this.getUserDetail(this.view, this.module);
          }
        });
    },
    onInvoiceChange2() {
      let data = this.$refs.shipfile.files[0];

      const formData = new FormData();
      formData.append("document", data);

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      // if (this.module == "land") {
      let url =
        ":10001/api/v1/user-management/" +
        this.module +
        "/" +
        this.view +
        "/ship_support_document";
      // }
      this.$http
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal2 = true;
            this.getUserDetail(this.view, this.module);
          }
        });
    },
    onInvoiceChange3() {
      let data = this.$refs.transporterfile.files[0];

      const formData = new FormData();
      formData.append("document", data);

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      let url =
        ":10001/api/v1/user-management/" +
        this.module +
        "/" +
        this.view +
        "/transporter_support_document";
      this.$http
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal2 = true;
            this.getUserDetail(this.view, this.module);
          }
        });
    },

    onFileChangeTransporter(event) {
      // this.uploadload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        // this.quotitle = filesArray.map(file => file.name).join(', ');

        const uploadPromises = [];

        // this.uploadload = true;
        // this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http.post(
            ":10001/api/v1/user-management/" + this.module + "/" + this.view + "/transporter_support_document",
            formData,
            {
              headers: {
                Authorization: `Bearer ${getStorage("token")}`,
                "Content-Type": "multipart/form-data",
              },
            }
          ).then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log('why')
              setTimeout(() => {
                this.getUserDetail(this.view, this.module);
              }, 1000);
              // this.message = response;
            } else {
              console.log("data tak masuk");
              swal({
                title: "Data Error!",
                text: `${res.message}`,
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }
          }).catch((error) => {
            console.error("Upload failed:", error);
          });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises).then(() => {
          this.modals.successUploadModal = true;
          // this.btnsubmit = false;
          t.value = '';
        }).catch((error) => {
          console.error("One or more uploads failed:", error);
        }).finally(() => {
          // this.uploadload = false;
          // this.buttondisabled = false;
        });
      } else {
        // this.quotitle = "";
      }
    },

    onInvoiceChange4() {
      let data = this.$refs.doefile.files[0];

      const formData = new FormData();
      formData.append("document", data);

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      // if (this.module == "land") {
      let url =
        ":10001/api/v1/user-management/" +
        this.module +
        "/" +
        this.view +
        "/doe_support_document";
      // }
      this.$http
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal2 = true;
            this.getUserDetail(this.view, this.module);
          }
        });
    },
    onInvoiceChange5() {
      let data = this.$refs.authorityfile.files[0];

      const formData = new FormData();
      formData.append("document", data);

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      let url =
        ":10001/api/v1/user-management/" +
        this.module +
        "/" +
        this.view +
        "/authority_support_document";
      this.$http
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal2 = true;
            this.getUserDetail(this.view, this.module);
          }
        });
    },
    addpic() {
      if (this.view != 'add') {
        this.picdetails.push({
          userid: 0,
          username: this.newpicname,
          useremail: this.newpicemail,
          userphonenumber: this.newpicphoneno,
          userfaxnumber: this.newpicfaxno,
          password: "",
          confirmpassword: "",
          flag: "new",
        });
        this.newpicname = '';
        this.newpicemail = '';
        this.newpicphoneno = '';
        this.newpicfaxno = '';

        this.modals.addPIC = false;
        this.modals.doneaddPIC = true;
      } else {
        this.picdetails.push({
          userid: 0,
          username: "",
          useremail: "",
          userphonenumber: "",
          userfaxnumber: "",
          password: "",
          confirmpassword: "",
          flag: "new",
        });
      }
    },
    addship() {
      this.ships.push({
        shipname: "",
        shiptype: "",
        imonumber: "",
        grosstonnage: "",
        deadweighttonnage: "",
        operatorname: "",
        callsign: "",
        flag: "",
      });
    },
    adddriver(tabs, name, nric) {
      tabs.push({
        driver_name: name,
        driver_nric: nric,
      });

      this.newname = '';
      this.newnric = '';
    },
    addnewdriver(name, nric) {
      this.newdriver.push({
        driver_name: name,
        driver_nric: nric,
      });

      this.newname = '';
      this.newnric = '';
    },
    removenewdriver(index) {
      console.log(index);
      if (index >= 0 && index < this.newdriver.length) {
        this.newdriver.splice(index, 1);
      }
    },
    addtruck(tabs, num) {
      tabs.push({
        vehicle_reg_num: num,
      });
      this.newtruck = '';
    },
    addnewtruck(num) {
      this.newtrucks.push({
        vehicle_reg_num: num,
      });
      this.newtruck = '';
    },
    removenewtruck(index) {
      console.log(index);
      if (index >= 0 && index < this.newtrucks.length) {
        this.newtrucks.splice(index, 1);
      }
    },
    addnewship() {
      let obj = {
        ship_name: this.newshipname,
        imo_number: this.newimo,
        ship_type_id: this.newshiptype,
        gross_tonnage: parseInt(this.newgross),
        deadweight_tonnage: parseInt(this.newtonnage),
        operator_name: this.newoperation,
        call_sign: this.newcallsign,
        flag_id: this.newflag,
        ship_document: [],
      }

      console.log(obj)

      this.$http
        .post(":10001/api/v1/user-management/update/" + this.module + "/" + this.view + "/ship", obj)
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Adding new ship success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.modals.addTransporter = false;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                  this.modals.addShip = false;
                  this.newshipname = '';
                  this.newshiptype = 0;
                  this.newimo = '';
                  this.newgross = 0;
                  this.newtonnage = 0;
                  this.newoperation = '';
                  this.newcallsign = '';
                  this.newflag = 0;

                }, 1000);
              }
            });
          } else {
            console.log("ship not added", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Adding new ship failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },
    addtransporter() {
      let obj = {
        transporter_name: this.newtransname,
        transporter_address: this.newtransaddress,
        transporter_phone: this.newtransphoneno,
        transporter_fax: this.newtransfaxno,
        doe_no: this.newtransdoeno,
      }

      console.log(obj)

      this.$http
        .post(":10001/api/v1/user-management/update/" + this.module + "/" + this.companyid + "/transporter", obj)
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Adding new transporter success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.modals.addTransporter = false;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                  this.newtransname = '';
                  this.newtransaddress = '';
                  this.newtransphoneno = '';
                  this.newtransfaxno = '';
                  this.newtransdoeno = '';
                }, 1000);
              }
            });
          } else {
            console.log("transporter not added", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Adding new transporter failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },
    getServiceLocation() {
      this.selects.servicelocations = [];
      this.$http.get(":10001/api/v1/reference/service-location")
        .then((res) => {
          if (res.error) {
            console.error(res.message)
            throw new Error("Fail to fetch service_location")
          }
          const obj = []
          for (const service_location of res.message) {
            const { ServiceLocationId, Location } = service_location
            if (obj.some(e => e.value === value)) {
              console.log(`duplicate entries for service_location_id: ${ServiceLocationId}`)
              continue
            }
            obj.push({ value: ServiceLocationId, label: Location })
          }
          this.selects.servicelocations = obj
        })
        .catch(err => console.error(err))

    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },

    toggleShoww(index) {
      this.$set(
        this.picdetails[index],
        "showPassword",
        !this.picdetails[index].showPassword
      );
      // this.picdetails[index].showPassword = !this.picdetails[index].showPassword;
      console.log("nape tak tekan?");
    },
    toggleShoww1(index) {
      this.$set(
        this.picdetails[index],
        "showPassword1",
        !this.picdetails[index].showPassword1
      );

      // this.picdetails[index].showPassword1 = !this.picdetails[index].showPassword1;
      console.log("tekan ke tak?");
    },

    getBack() {
      this.$router.push("/Users");
    },

    // saveDraft() {
    //   console.log("save draft");
    // },

    getRoles() {
      this.selects.usertypes = [];

      this.$http.get(":10001/api/v1/setting/roles").then((res) => {
        if (res.error) {
          console.error(res.message)
          throw new Error("Roles API errors")
        }
        this.selects.usertypes = res.message[0].Position.map(users => {
          return { label: users.position_name, value: users.position_id }
        })


      })
        .catch(err => console.error(err))
        .finally(() => console.log('getRoles done'))

    },

    successModal() {
      this.modals.successModal = true;
    },
    failedModal() {
      this.modals.failedModal = true;
    },
    closeFailedModal() {
      this.modals.failedModal = false;
    },

    saveTransporter(transporters, index) {
      let flag = '';

      //kena adjust
      let driverlist = [];
      for (var i = 0; i < this.driverdetails.length; i++) {
        if (
          this.driverdetails[i].drivername != "" &&
          this.driverdetails[i].nric != ""
        ) {
          let driver = {
            driver_name: this.driverdetails[i].drivername,
            driver_nric: this.driverdetails[i].nric,
          };
          driverlist.push(driver);
          flag = "checked";
        } else {
          flag = "notcheck";
        }
      }

      //kena adjust
      let vehiclelist = [];
      for (var i = 0; i < this.truckdetails.length; i++) {
        if (this.truckdetails[i].registrationno != "") {
          let vehicle = {
            vehicle_reg_num: this.truckdetails[i].registrationno,
          };
          vehiclelist.push(vehicle);
          flag = "checked";
        } else {
          flag = "notcheck";
        }
      }

      //kena adjust
      let transporter = [];
      let obj = {
        transporter_name: transporters[index].name,
        doe_no: transporters[index].doeno,
        transporter_address: transporters[index].address,
        transporter_phone: transporters[index].phoneno,
        transporter_fax: transporters[index].faxno,
        driver: driverlist,
        vehicle: vehiclelist,
        // transporter_documents: [],
      };

      console.log(obj);
      // transporter.push(obj);

      if (flag == "checked") {
        // add new user
        if (this.view == "add") {
          this.$http
            .post(":10001/api/v1/user-management/" + this.module + "/" + this.companyid + "/transporter", obj)
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.modals.successModal = true;
                this.message = response;
                // this.$router.push("/Users");
              } else {
                this.modals.failedModal = true;
              }
            })
            .catch((err) => {
              this.message = err.response.data.message;
              this.modals.failedModal = true;
              this.errmsg = err.response.data.message;
            });
        }

        // edit existing user
        if (this.view != "add") {
          let userid = this.$route.params.actionflag;

          this.$http
            .put(
              ":10001/api/v1/user-management/update/" +
              this.module +
              "/" +
              this.companyid +
              "/transporter/" + transporters[index].id,
              obj
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal = true;
              }
            })
            .catch((err) => {
              this.message = err.response.data.message;
              this.modals.failedModal = true;
              this.errmsg = err.response.data.message;
            });
        }
      } else {
        this.message = "Please fill all the required column";
        this.modals.infoModal = true;
      }
    },

    handleAddVessel() {
      let flag = "notcheck";
      let obj = {};
      let picc = [];

      // check ship
      let shipss = [];
      for (var i = 0; i < this.ships.length; i++) {
        if (
          this.ships[i].shipname != "" &&
          this.ships[i].shiptype != "" &&
          this.ships[i].imonumber != "" &&
          this.ships[i].grosstonnage != "" &&
          this.ships[i].deadweighttonnage != "" &&
          this.ships[i].operatorname != "" &&
          this.ships[i].callsign != "" &&
          this.ships[i].flag != ""
        ) {
          let oss = {
            ship_name: this.ships[i].shipname,
            imo_number: this.ships[i].imonumber,
            ship_type_id: this.ships[i].shiptype,
            gross_tonnage: parseInt(this.ships[i].grosstonnage),
            deadweight_tonnage: parseInt(this.ships[i].deadweighttonnage),
            operator_name: this.ships[i].operatorname,
            call_sign: this.ships[i].callsign,
            flag_id: this.ships[i].flag,
            ship_documents: [],
          };
          shipss.push(oss);
          flag = "checked";
        } else {
          flag = "notcheck";
        }
      }

      let picdetails = [];
      for (var i = 0; i < this.picdetails.length; i++) {
        if (
          (this.picdetails[i].username != "") &
          (this.picdetails[i].useremail != "")
        ) {
          let pic = {
            user_id: this.picdetails[i].userid,
            user_name: this.picdetails[i].username,
            user_email: this.picdetails[i].useremail,
            user_phone_number: this.picdetails[i].userphonenumber,
            user_fax_number: this.picdetails[i].userfaxnumber,
            password: this.picdetails[i].password,
            confirm_password: this.picdetails[i].confirmpassword,
          };
          picdetails.push(pic);
        }
      }

      obj = {
        role_id: 3,
        position_id: this.position,
        operation_type_id: 1,
        company_name: this.companyname,
        company_address: this.companyaddress,
        company_reg_num: this.companyregno,
        company_phone_number: this.companyphonenumber,
        company_fax_number: this.companyfaxno,
        documents: [],
        pic: picdetails,
        ship: shipss,
      };

      console.log('data basic detail', obj)

      this.$http
        .post(
          "/api/v1/user-management/vessel",
          obj
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Vessel registered.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                // this.modals.successModal = false;
                this.redirect();
              }
            });
          } else {
            console.log("vendor not register", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Registering vessel failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });

    },

    //kena adjust sini
    handleAddVendor(pic) {
      let obj = {};
      let picc = [];
      let doedoc = [];
      let doc = [];
      let transdoc = [];

      for (var i = 0; i < this.alldoe.length; i++) {
        doedoc.push(this.alldoe[i].fileid);
      }

      for (var i = 0; i < this.allInvoice.length; i++) {
        doc.push(this.allInvoice[i].fileid);
      }

      for (var i = 0; i < pic.length; i++) {
        let pics = {
          user_id: pic[i].userid,
          user_name: pic[i].username,
          user_email: pic[i].useremail,
          user_phone_number: pic[i].userphonenumber,
          user_fax_number: pic[i].userfaxnumber,
          password: pic[i].password,
          confirm_password: pic[i].confirmpassword,
        };

        picc.push(pics);
      }

      for (var i = 0; i < this.newtransdocs.length; i++) {
        transdoc.push(this.newtransdocs[i].document_id);
      }

      for (var i = 0; i < this.newsupportdoc.length; i++) {
        doc.push(this.newsupportdoc[i].document_id);
      }

      for (var i = 0; i < this.newdoedoc.length; i++) {
        doedoc.push(this.newdoedoc[i].document_id);
      }

      let transporterr = {
        transporter_name: this.newtransname,
        transporter_address: this.newtransaddress,
        transporter_phone: this.newtransphoneno,
        transporter_fax: this.newtransfaxno,
        doe_no: this.newtransdoeno,
        driver: this.newdriver,//belum ok
        vehicle: this.newtrucks,//belum ok
        transporter_documents: transdoc,
      };

      obj = {
        pic: picc,
        transporter: transporterr,
        company_name: this.companyname,
        company_address: this.companyaddress,
        company_phone_number: this.companyphonenumber,
        company_fax_number: this.companyfaxno,
        doe_licence: this.doelicense,
        doe_expired_at: this.doeexpired == ""
          ? null
          : moment(this.doeexpired).format("YYYY-MM-DD"),
        facility_type_id: this.selects.facility,
        doe_documents: doedoc,//belum ok
        documents: doc,//belum ok
      }

      console.log('data basic detail', obj)

      this.$http
        .post(
          "/api/v1/user-management/vendor",
          obj
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Vendor registered.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                // this.modals.successModal = false;
                this.redirect();
              }
            });
          } else {
            console.log("vendor not register", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Registering vendor failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    handleUpdateVendor(pic) {
      let obj = {};
      let picc = [];
      let doedoc = [];
      let doc = [];

      for (var i = 0; i < this.alldoe.length; i++) {
        doedoc.push(this.alldoe[i].fileid);
      }

      for (var i = 0; i < this.allInvoice.length; i++) {
        doc.push(this.allInvoice[i].fileid);
      }

      for (var i = 0; i < pic.length; i++) {
        let pics = {
          user_id: pic[i].userid,
          user_name: pic[i].username,
          user_email: pic[i].useremail,
          user_phone_number: pic[i].userphonenumber,
          user_fax_number: pic[i].userfaxnumber,
          password: pic[i].password,
          confirm_password: pic[i].confirmpassword,
        };

        picc.push(pics);
      }

      obj =
      {
        pic: picc,
        company_name: this.companyname,
        company_address: this.companyaddress,
        company_phone_number: this.companyphonenumber,
        company_fax_number: this.companyfaxno,
        doe_licence: this.doelicense,
        doe_expired_at: this.doeexpired == ""
          ? null
          : moment(this.doeexpired).format("YYYY-MM-DD"),
        facility_type_id: this.selects.facility,
        doe_documents: doedoc,
        documents: doc,
      }

      console.log('data basic detail', obj)

      this.$http
        .put(
          "/api/v1/user-management/update/vendor/" + this.view,
          obj
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Vendor updated.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                // this.modals.successModal = false;
              }
            });
          } else {
            console.log("transport not update", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Updating vendor failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    handleUpdateTransporter(transporter) {
      let obj = {};

      obj = {
        transporter_name: transporter.transporter_name,
        transporter_address: transporter.transporter_address,
        transporter_phone: transporter.transporter_phone,
        transporter_fax: transporter.transporter_fax,
        doe_no: transporter.doe_no,
        driver: transporter.drivers,
        vehicle: transporter.vehicles,
      };

      console.log('data transporter', obj)
      console.log('transporter', transporter)

      this.$http
        .put(
          "/api/v1/user-management/update/vendor/" + this.view + "/transporter/" + transporter.transporter_id,
          obj
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Transporter updated.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                // this.modals.successModal = false;
              }
            });
          } else {
            console.log("transport not update", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Updating transporter failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    handleUpdateVessel(pic) {
      let obj = {};
      let picc = [];
      let doedoc = [];
      let doc = [];

      for (var i = 0; i < this.alldoe.length; i++) {
        doedoc.push(this.alldoe[i].fileid);
      }

      for (var i = 0; i < this.allInvoice.length; i++) {
        doc.push(this.allInvoice[i].fileid);
      }

      for (var i = 0; i < pic.length; i++) {
        let pics = {
          user_id: pic[i].userid,
          user_name: pic[i].username,
          user_email: pic[i].useremail,
          user_phone_number: pic[i].userphonenumber,
          user_fax_number: pic[i].userfaxnumber,
          password: pic[i].password,
          confirm_password: pic[i].confirmpassword,
        };

        picc.push(pics);
      }

      obj = {
        pic: picc,
        company_name: this.companyname,
        company_address: this.companyaddress,
        company_phone_number: this.companyphonenumber,
        company_fax_number: this.companyfaxno,
        position_id: this.position,
      }

      console.log('data basic detail', obj)

      this.$http
        .put(
          "/api/v1/user-management/update/vessel/" + this.view,
          obj
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Vessel updated.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                // this.modals.successModal = false;
              }
            });
          } else {
            console.log("vessel not update", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Updating vessel failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    handleUpdateShip(ship) {
      let shipdoc = [];
      let obj = {};

      for (var i = 0; i < this.alldoe.length; i++) {
        shipdoc.push({
          ship_document_id: this.alldoe[i].fileid
        });
      }

      obj = {
        ship_name: ship.shipname,
        imo_number: ship.imonumber,
        ship_type_id: ship.shiptype,
        gross_tonnage: ship.grosstonnage,
        deadweight_tonnage: ship.deadweighttonnage,
        operator_name: ship.operatorname,
        call_sign: ship.callsign,
        flag_id: ship.flag,
        ship_document: shipdoc,
      };

      console.log('data ship', obj)
      console.log('ship', ship)

      this.$http
        .put(
          "/api/v1/profile/vessel/ship/" + ship.ship_id,
          obj
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Ship updated.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                // this.modals.successModal = false;
              }
            });
          } else {
            console.log("ship not update", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Updating ship failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    // handleAddVendor(transporter) {
    //   let obj = {};

    //   obj = {
    //     transporter_name: transporter.transporter_name,
    //     transporter_address: transporter.transporter_address,
    //     transporter_phone: transporter.transporter_phone,
    //     transporter_fax: transporter.transporter_fax,
    //     doe_no: transporter.doe_no,
    //     driver: transporter.drivers,
    //     vehicle: transporter.vehicles,
    //   };

    //   console.log('data transporter', obj)
    //   console.log('transporter', transporter)

    //   this.$http
    //     .put(
    //       "/api/v1/user-management/update/vendor/" + this.view + "/transporter",
    //       obj
    //     )
    //     .then((res) => {
    //       if (!res.error) {
    //         swal({
    //           title: `Success!`,
    //           text: "Transporter updated.",
    //           buttonsStyling: false,
    //           confirmButtonClass: "btn btn-primary btn-fill",
    //           type: "success",
    //         }).then((result) => {
    //           console.log(result);
    //           if (result.value) {
    //             // this.modals.successModal = false;
    //           }
    //         });
    //       } else {
    //         console.log("transport not update", response);
    //       }
    //     })
    //     .catch((err) => {
    //       swal({
    //         title: `Error!`,
    //         text: "Updating transporter failed.",
    //         buttonsStyling: false,
    //         confirmButtonClass: "btn btn-cancel btn-fill",
    //         type: "error",
    //       });
    //     });
    // },

    //FIX PAYLOAD
    handleDone() {
      let flag = "notcheck";
      let obj = {};

      if (this.module == "afes") {
        // check compulsary data
        if (
          this.fullname != "" &&
          this.email != "" &&
          this.phoneno != "" &&
          this.selects.usertype != "" &&
          this.staffID != ""
        ) {
          obj = {
            user_name: this.fullname,
            user_email: this.email,
            password: this.password,
            confirm_password: this.confirmpassword,
            user_phone_number: this.phoneno,
            position_id: this.selects.usertype,
            role_id: 1,
            employee_id: this.staffID,
            remarks: this.remarks,
            service_location_id:
              this.selects.servicelocation == ""
                ? null
                : this.selects.servicelocation,
          };

          flag = "checked";
        } else {
          this.message = "Please fill all the required column";
          this.modals.infoModal = true;
          flag = "notcheck";
        }
      }

      if (this.module == "land") {
        // check compulsary data
        for (var i = 0; i < this.picdetails.length; i++) {
          if (this.view == "add") {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != "" &&
              this.picdetails[i].password != "" &&
              this.picdetails[i].confirmpassword != "" &&
              this.companyname != "" &&
              this.companyregno != "" &&
              this.companyaddress != "" &&
              this.companyphonenumber != "" &&
              this.position != ""
            ) {
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          } else {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != "" &&
              this.companyname != "" &&
              this.companyregno != "" &&
              this.companyaddress != "" &&
              this.companyphonenumber != "" &&
              this.position != ""
            ) {
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          }
        }

        // get pic details
        let picdetails = [];
        console.log(this.picdetails[0]);
        for (var i = 0; i < this.picdetails.length; i++) {
          if (
            (this.picdetails[i].username != "") &
            (this.picdetails[i].useremail != "")
          ) {
            let pic = {
              user_id: this.picdetails[i].userid,
              user_name: this.picdetails[i].username,
              user_email: this.picdetails[i].useremail,
              user_phone_number: this.picdetails[i].userphonenumber,
              user_fax_number: this.picdetails[i].userfaxnumber,
              password: this.picdetails[i].password,
              confirm_password: this.picdetails[i].confirmpassword,
            };
            picdetails.push(pic);
          }
        }
        obj = {
          pic: picdetails,
          position_id: this.position,
          role_id: 2,
          company_name: this.companyname,
          company_address: this.companyaddress,
          company_reg_num: this.companyregno,
          company_phone_number: this.companyphonenumber,
          company_fax_number: this.companyfaxno,
          documents: [], // id gets from upload documents,
        };
      }

      if (this.module == "vessel") {
        // check compulsary data
        for (var i = 0; i < this.picdetails.length; i++) {
          if (this.view == "add") {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != "" &&
              this.picdetails[i].password != "" &&
              this.picdetails[i].confirmpassword != "" &&
              this.companyname != "" &&
              this.companyregno != "" &&
              this.companyaddress != "" &&
              this.companyphonenumber != "" &&
              this.position != ""
            ) {
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          } else {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != "" &&
              this.companyname != "" &&
              this.companyregno != "" &&
              this.companyaddress != "" &&
              this.companyphonenumber != "" &&
              this.position != ""
            ) {
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          }
        }

        // check ship
        let shipss = [];
        for (var i = 0; i < this.ships.length; i++) {
          if (
            this.ships[i].shipname != "" &&
            this.ships[i].shiptype != "" &&
            this.ships[i].imonumber != "" &&
            this.ships[i].grosstonnage != "" &&
            this.ships[i].deadweighttonnage != "" &&
            this.ships[i].operatorname != "" &&
            this.ships[i].callsign != "" &&
            this.ships[i].flag != ""
          ) {
            let oss = {
              ship_name: this.ships[i].shipname,
              imo_number: this.ships[i].imonumber,
              ship_type_id: this.ships[i].shiptype,
              gross_tonnage: parseInt(this.ships[i].grosstonnage),
              deadweight_tonnage: parseInt(this.ships[i].deadweighttonnage),
              operator_name: this.ships[i].operatorname,
              call_sign: this.ships[i].callsign,
              flag_id: this.ships[i].flag,
              ship_documents: [],
            };
            shipss.push(oss);
            flag = "checked";
          } else {
            flag = "notcheck";
          }
        }

        let picdetails = [];
        for (var i = 0; i < this.picdetails.length; i++) {
          if (
            (this.picdetails[i].username != "") &
            (this.picdetails[i].useremail != "")
          ) {
            let pic = {
              user_id: this.picdetails[i].userid,
              user_name: this.picdetails[i].username,
              user_email: this.picdetails[i].useremail,
              user_phone_number: this.picdetails[i].userphonenumber,
              user_fax_number: this.picdetails[i].userfaxnumber,
              password: this.picdetails[i].password,
              confirm_password: this.picdetails[i].confirmpassword,
            };
            picdetails.push(pic);
          }
        }

        obj = {
          role_id: 3,
          position_id: this.position,
          operation_type_id: 1,
          company_name: this.companyname,
          company_address: this.companyaddress,
          company_reg_num: this.companyregno,
          company_phone_number: this.companyphonenumber,
          company_fax_number: this.companyfaxno,
          documents: [],
          pic: picdetails,
          ship: shipss,
        };
      }

      if (this.module == "vendor") {
        let picdetails = [];
        for (var i = 0; i < this.picdetails.length; i++) {
          if (this.view == "add") {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != "" &&
              this.picdetails[i].password != "" &&
              this.picdetails[i].confirmpassword != ""
            ) {
              let pic = {
                user_id: this.picdetails[i].userid,
                user_name: this.picdetails[i].username,
                user_email: this.picdetails[i].useremail,
                user_phone_number: this.picdetails[i].userphonenumber,
                user_fax_number: this.picdetails[i].userfaxnumber,
                password: this.picdetails[i].password,
                confirm_password: this.picdetails[i].confirmpassword,
              };
              picdetails.push(pic);
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          } else {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != ""
            ) {
              let pic = {
                user_id: this.picdetails[i].userid,
                user_name: this.picdetails[i].username,
                user_email: this.picdetails[i].useremail,
                user_phone_number: this.picdetails[i].userphonenumber,
                user_fax_number: this.picdetails[i].userfaxnumber,
                password: this.picdetails[i].password,
                confirm_password: this.picdetails[i].confirmpassword,
              };
              picdetails.push(pic);
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          }
        }

        //kena adjust
        let driverlist = [];
        for (var i = 0; i < this.driverdetails.length; i++) {
          if (
            this.driverdetails[i].drivername != "" &&
            this.driverdetails[i].nric != ""
          ) {
            let driver = {
              driver_name: this.driverdetails[i].drivername,
              driver_nric: this.driverdetails[i].nric,
            };
            driverlist.push(driver);
            flag = "checked";
          } else {
            flag = "notcheck";
          }
        }

        //kena adjust
        let vehiclelist = [];
        for (var i = 0; i < this.truckdetails.length; i++) {
          if (this.truckdetails[i].registrationno != "") {
            let vehicle = {
              registration_no: this.truckdetails[i].registrationno,
            };
            vehiclelist.push(vehicle);
            flag = "checked";
          } else {
            flag = "notcheck";
          }
        }

        //kena adjust
        let transporter = [];
        let objj = {
          transporter_name: this.transportername,
          doe_no: this.doeno,
          transporter_address: this.transporteraddress,
          transporter_phone: this.transporterphoneno,
          transporter_fax: this.transporterfax,
          driver: driverlist,
          vehicle: vehiclelist,
          transporter_documents: [],
        };
        transporter.push(objj);

        let swcodes = [];

        for (var i = 0; i < this.wastehandle.length; i++) {
          swcodes.push(this.wastehandle[i].waste_type_id);
        }

        obj = {
          pic: picdetails,
          // transporter: transporter, //ni kena asing
          company_name: this.companyname,
          company_address: this.companyaddress,
          // company_reg_num: this.companyregno,
          company_phone_number: this.companyphonenumber,
          company_fax_number: this.companyfaxno,
          doe_licence: this.doelicense,
          doe_expired_at:
            this.doeexpired == ""
              ? null
              : moment(this.doeexpired).format("YYYY-MM-DD"),
          documents: [], // id gets from upload documents,

          waste_code_id: swcodes, //ambik from sw codes
          facility_type_id: this.facilitytype,
          doe_documents: [],
        };
      }

      if (this.module == "authority") {
        let picdetails = [];
        for (var i = 0; i < this.picdetails.length; i++) {
          if (this.view == "add") {
            if (
              // this.picdetails[i].username != "" &&
              // this.picdetails[i].useremail != "" &&
              // this.picdetails[i].userphonenumber != "" &&
              // this.picdetails[i].password != "" &&
              // this.picdetails[i].confirmpassword != "" &&
              this.agencyname != "" &&
              this.phonenumber != ""
            ) {
              let pic = {
                user_id: this.picdetails[i].userid,
                user_name: this.picdetails[i].username,
                user_email: this.picdetails[i].useremail,
                user_phone_number: this.picdetails[i].userphonenumber,
                user_fax_number: this.picdetails[i].userfaxnumber,
                password: this.picdetails[i].password,
                confirm_password: this.picdetails[i].confirmpassword,
              };
              picdetails.push(pic);
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          } else {
            if (
              // this.picdetails[i].username != "" &&
              // this.picdetails[i].useremail != "" &&
              // this.picdetails[i].userphonenumber != "" &&
              this.agencyname != "" &&
              this.phonenumber != ""
            ) {
              let pic = {
                user_id: this.picdetails[i].userid,
                user_name: this.picdetails[i].username,
                user_email: this.picdetails[i].useremail,
                user_phone_number: this.picdetails[i].userphonenumber,
                user_fax_number: this.picdetails[i].userfaxnumber,
                password: this.picdetails[i].password,
                confirm_password: this.picdetails[i].confirmpassword,
              };
              picdetails.push(pic);
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          }
        }
        obj = {
          pic: picdetails,
          agency_name: this.agencyname,
          phone_number: this.phonenumber,
          fax_number: this.faxnumber,
          documents: [],
        };
      }

      console.log('data here', obj);

      console.log("datas", obj);
      if (flag == "checked") {
        // add new user
        if (this.view == "add") {
          this.$http
            .post(":10001/api/v1/user-management/" + this.module, obj)
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.modals.successModal = true;
                this.message = response;
                // this.$router.push("/Users");
              } else {
                this.modals.failedModal = true;
              }
            })
            .catch((err) => {
              this.message = err.response.data.message;
              this.modals.failedModal = true;
              this.errmsg = err.response.data.message;
            });
        }

        // edit existing user
        if (this.view != "add") {
          let userid = this.$route.params.actionflag;

          this.$http
            .put(
              ":10001/api/v1/user-management/update/" +
              this.module +
              "/" +
              userid,
              obj
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log('sini', response);
                this.message = response;
                this.modals.successModal = true;
              }
            })
            .catch((err) => {
              this.message = err.response.data.message;
              this.modals.failedModal = true;
              this.errmsg = err.response.data.message;
            });
        }
      } else {
        this.message = "Please fill all the required column";
        this.modals.infoModal = true;
      }
    },
    getUserDetail(id, module) {
      console.log("hihi");
      this.$http
        .get(":10001/api/v1/user-management/" + module + "/" + id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            if (this.module == "afes") {
              this.fullname = response.user_name;
              this.email = response.user_email;
              this.phoneno = response.user_phone_number;
              this.selects.usertype = parseInt(response.position_id);
              this.staffID = response.employee_id;
              this.remarks = response.remarks;
              this.selects.servicelocation = response.service_location_id;

              this.image = response.signature == null ? null : {
                url: response.signature.url,
                id: response.signature.document_id,
              };
            }

            if (this.module == "land") {
              this.companyname = response.company_name;
              this.companyregno = response.company_reg_num;
              this.companyaddress = response.company_address;
              this.companyfaxno = response.fax_number;
              this.companyphonenumber = response.phone_number;
              this.position = response.position_id;

              this.allInvoice = [];
              if (response.company_documents != null) {
                for (var i = 0; i < response.company_documents.length; i++) {
                  let obj = {
                    filename: response.company_documents[i].meta.filename,
                    fileid: response.company_documents[i].company_document_id,
                    fileurl: response.company_documents[i].url,
                  };
                  this.allInvoice.push(obj);
                }
              }
              this.picdetails = [];
              for (var i = 0; i < response.pic.length; i++) {
                let obj = {
                  userid: response.pic[i].user_id,
                  username: response.pic[i].user_name,
                  useremail: response.pic[i].user_email,
                  userphonenumber: response.pic[i].user_phone_number,
                  userfaxnumber: response.pic[i].user_fax_number,
                };
                this.picdetails.push(obj);
              }
            }
            // this.allships = [];
            this.vesseltabs = [];
            if (this.module == "vessel") {
              this.vesseltabs.push(
                { name: "Details", content: "Content for Tab 1" },
                { name: "PIC", content: "Content for Tab 2" },
              );

              this.position = response.position_id;

              this.companyname = response.company_name;
              this.companyregno = response.company_reg_num;
              this.companyaddress = response.company_address;
              this.companyfaxno = response.fax_number;
              this.companyphonenumber = response.phone_number;
              this.ships = [];


              for (var i = 0; i < response.ship.length; i++) {
                let shipdocs = [];

                if (response.ship[i].ship_support_documents != null) {
                  for (var j = 0; j < response.ship[i].ship_support_documents.length; j++) {
                    let objj = {
                      fileid: response.ship[i].ship_support_documents[j].ship_document_id,
                      fileurl: response.ship[i].ship_support_documents[j].url,
                      // filename: 'nam',
                      filename: response.ship[i].ship_support_documents[j].meta.filename,
                    };

                    shipdocs.push(objj);



                  }
                }

                let obj = {
                  ship_id: response.ship[i].ship_id,
                  shipname: response.ship[i].ship_name,
                  shiptype: response.ship[i].ship_type_id,
                  imonumber: response.ship[i].imo_number,
                  grosstonnage: response.ship[i].gross_tonnage,
                  deadweighttonnage: response.ship[i].deadweight_tonnage,
                  operatorname: response.ship[i].operator_name,
                  callsign: response.ship[i].call_sign,
                  flag: response.ship[i].flag_id,
                };
                this.ships.push(obj);

                this.vesseltabs.push(
                  {
                    name: "Ship " + response.ship[i].ship_name,
                    content: "Content for Tab 1",

                    ship_id: response.ship[i].ship_id,
                    shipname: response.ship[i].ship_name,
                    shiptype: response.ship[i].ship_type_id,
                    imonumber: response.ship[i].imo_number,
                    grosstonnage: response.ship[i].gross_tonnage,
                    deadweighttonnage: response.ship[i].deadweight_tonnage,
                    operatorname: response.ship[i].operator_name,
                    callsign: response.ship[i].call_sign,
                    flag: response.ship[i].flag_id,
                    shipdoc: shipdocs,
                  },

                )
              }
              // this.shipname = response.ship.ship_name;
              // this.shiptype = response.ship.ship_type_id;
              // this.imonumber = response.ship.imo_number;
              // this.grosstonnage = response.ship.gross_tonnage;
              // this.deadweighttonnage = response.ship.deadweight_tonnage;
              // this.operatorname = response.ship.operator_name;
              // this.callsign = response.ship.call_sign;
              // this.flag = response.ship.flag_id;

              this.allInvoice = [];
              if (response.company_documents != null) {
                for (var i = 0; i < response.company_documents.length; i++) {
                  let obj = {
                    filename: response.company_documents[i].meta.filename,
                    fileid: response.company_documents[i].company_document_id,
                    fileurl: response.company_documents[i].url,
                  };
                  this.allInvoice.push(obj);
                }
              }

              this.allships = [];
              if (response.ship != null) {
                for (var i = 0; i < response.ship.length; i++) {
                  for (
                    var j = 0;
                    j < response.ship[i].ship_support_documents.length;
                    j++
                  ) {
                    let obj = {
                      filename:
                        response.ship[i].ship_support_documents[j].meta
                          .filename,
                      fileid:
                        response.ship[i].ship_support_documents[j]
                          .ship_document_id,
                      fileurl: response.ship[i].ship_support_documents[j].url,
                    };
                    this.allships.push(obj);
                  }
                }
              }

              this.picdetails = [];
              for (var i = 0; i < response.pic.length; i++) {
                let obj = {
                  userid: response.pic[i].user_id,
                  username: response.pic[i].user_name,
                  useremail: response.pic[i].user_email,
                  userphonenumber: response.pic[i].user_phone_number,
                  userfaxnumber: response.pic[i].user_fax_number,
                };
                this.picdetails.push(obj);
              }
              // console.log(obj);
            }

            let formatter = new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            this.tabs = [
            ];
            if (this.module == "vendor") {
              this.tabs.push(
                { name: "Details", content: "Content for Tab 1", total: 0 },
                { name: "PIC", content: "Content for Tab 2" },
              );
              this.transporterdetails = [];
              this.drivers = [];
              this.truckdetails = [];


              if (response.transporter !== null) {
                console.log('vendor dtaa', response.transporter)

                for (const transporter of response.transporter) {
                  const drivers = []
                  const vehicles = []
                  const transporter_doe_support_documents = []
                  const transporter_support_documents = []
                  for (const driver of transporter.driver) {
                    {
                      //TO BE REMOVE
                      if (this.drivers.some(e => e.id === driver.driver_id)) {
                        console.log(`duplicate driver_id: ${driver.driver_id}`)
                      } else {
                        this.drivers.push({ id: driver.driver_id, name: driver.driver_name, nric: driver.driver_nric })
                      }
                    }

                    const { driver_id, driver_name, driver_nric } = driver
                    if (drivers.some(e => e.driver_id === driver_id)) {
                      console.log(`duplicate driver_id: ${driver.driver_id}`)
                      continue
                    }
                    drivers.push({ driver_id, driver_name, driver_nric })
                  }

                  for (const vehicle of transporter.vehicle) {
                    {
                      // TO BE REMOVE
                      if (this.truckdetails.some(e => e.id === vehicle.vehicle_id)) {
                        console.log(`duplicate vehicle_id: ${vehicle.vehicle_id}`)
                      } else {
                        this.truckdetails.push({ id: vehicle.vehicle_id, registrationno: vehicle.vehicle_reg_num })
                      }
                    }

                    const { vehicle_id, vehicle_reg_num } = vehicle
                    if (vehicles.some(e => e.vehicle_id === vehicle_id)) {
                      console.log(`duplicate vehicle_id: ${vehicle.vehicle_id}`)
                      continue
                    }
                    vehicles.push({ vehicle_id, vehicle_reg_num })
                  }

                  for (const transporter_doe_support_document of transporter.transporter_doe_support_documents) {
                    const { transporter_doe_document_id, url, meta, doe_expired_at, created_at } = transporter_doe_support_document
                    if (transporter_doe_support_documents.some(e => e.transporter_doe_document_id === transporter_doe_document_id)) {
                      console.log(`duplicate transporter_doe_support_document: ${transporter_doe_document_id}`)
                      continue
                    }
                    transporter_doe_support_documents.push({ transporter_doe_document_id, url, meta, doe_expired_at, created_at })
                  }

                  for (const transporter_support_document of transporter.transporter_support_documents) {
                    const { transporter_document_id, url, meta, created_at } = transporter_support_document
                    if (transporter_support_documents.some(e => e.transporter_document_id === transporter_document_id)) {
                      console.log(`duplicate transporter_support_document: ${transporter_document_id}`)
                      continue
                    }
                    transporter_support_documents.push({ transporter_document_id, url, meta, created_at })
                  }

                  console.log('file hre', transporter_support_documents)

                  this.transporterdetails.push({
                    // TO BE REMOVE
                    name: transporter.transporter_name,
                    doeno: transporter.doe_no,
                    address: transporter.transporter_address,
                    phoneno: transporter.transporter_phone,
                    faxno: transporter.transporter_fax,

                    // original response
                    doe_no: transporter.doe_no,
                    transporter_address: transporter.transporter_address,
                    transporter_fax: transporter.transporter_fax,
                    transporter_id: transporter.transporter_id,
                    transporter_name: transporter.transporter_name,
                    transporter_phone: transporter.transporter_phone,
                    drivers,
                    vehicles,
                    transporter_doe_support_documents,
                    transporter_support_documents,

                    // apa ni??
                    uploadload: false,
                  })

                  this.tabs.push(
                    {
                      name: "Transporter " + transporter.transporter_name, content: "Content for Tab 1" + transporter.transporter_name, total: 0,
                      // original response
                      doe_no: transporter.doe_no,
                      transporter_address: transporter.transporter_address,
                      transporter_fax: transporter.transporter_fax,
                      transporter_id: transporter.transporter_id,
                      transporter_name: transporter.transporter_name,
                      transporter_phone: transporter.transporter_phone,
                      drivers,
                      vehicles,
                      transporter_doe_support_documents,
                      transporter_support_documents,

                      // apa ni??
                      uploadload: false,
                    },

                  )


                } console.log('doc', this.tabs)
              }

              this.companyid = response.company_id;
              this.companyname = response.company_name;
              this.companyregno = response.company_reg_num;
              this.companyaddress = response.company_address;
              this.companyfaxno = response.fax_number;
              this.companyphonenumber = response.phone_number;
              this.doeexpired = response.doe_expired_at;

              this.transportername = response.transporter.transporter_name;
              this.doeno = response.transporter.doe_no;

              this.wastehandle = [];
              if (response.waste_handle != null) {
                for (var j = 0; j < response.waste_handle.length; j++) {
                  let obj = {
                    id: j,
                    waste_type_id: response.waste_handle[j].waste_type.waste_type_id,
                    buy_price: formatter.format(response.waste_handle[j].buy_price), //adjust balik
                    sell_price: formatter.format(response.waste_handle[j].sell_price), //adjust balik
                    waste_type_name: response.waste_handle[j].waste_type.name.split(' - ')[0],
                  };
                  this.wastehandle.push(obj);
                }

                console.log(this.wastehandle);
              }


              this.doelicense = response.doe_licence;
              this.facilitytype = response.facility_type_id;
              this.selects.sw = response.waste_handled;

              this.allInvoice = [];
              if (response.company_documents != null) {
                for (var i = 0; i < response.company_documents.length; i++) {
                  let obj = {
                    filename: response.company_documents[i].meta.filename,
                    fileid: response.company_documents[i].company_document_id,
                  };
                  this.allInvoice.push(obj);
                }
              }

              this.picdetails = [];
              for (var i = 0; i < response.pic.length; i++) {
                let obj = {
                  userid: response.pic[i].user_id,
                  username: response.pic[i].user_name,
                  useremail: response.pic[i].user_email,
                  userphonenumber: response.pic[i].user_phone_number,
                  userfaxnumber: response.pic[i].user_fax_number,
                };
                this.picdetails.push(obj);
              }

              if (this.module != 'vendor')
                this.alltransporter = [];
              if (response.transporter.transporter_support_documents != null) {
                for (
                  var i = 0;
                  i < response.transporter.transporter_support_documents.length;
                  i++
                ) {
                  let obj = {
                    filename:
                      response.transporter.transporter_support_documents[i].meta
                        .filename,
                    fileid:
                      response.transporter.transporter_support_documents[i]
                        .transporter_document_id,
                    fileurl:
                      response.transporter.transporter_support_documents[i].url,
                  };
                  this.alltransporter.push(obj);
                }
              }

              this.alldoe = [];
              if (response.doe_support_documents != null) {
                for (
                  var i = 0;
                  i < response.doe_support_documents.length;
                  i++
                ) {
                  let obj = {
                    filename: response.doe_support_documents[i].meta.filename,
                    fileid: response.doe_support_documents[i].doe_document_id,
                    fileurl: response.doe_support_documents[i].url,
                  };
                  this.alldoe.push(obj);
                }
              }
            }

            if (this.module == "authority") {
              this.agencyname = response.agency_name;
              this.phonenumber = response.phone_number;
              this.faxnumber = response.fax_number;

              this.allauthority = [];
              if (response.authority_support_documents != null) {
                for (
                  var i = 0;
                  i < response.authority_support_documents.length;
                  i++
                ) {
                  let obj = {
                    filename:
                      response.authority_support_documents[i].meta.filename,
                    fileid:
                      response.authority_support_documents[i]
                        .authority_document_id,
                    fileurl: response.authority_support_documents[i].url,
                  };
                  this.allauthority.push(obj);
                }
              }
              this.picdetails = [];
              for (var i = 0; i < response.pic.length; i++) {
                let obj = {
                  userid: response.pic[i].user_id,
                  username: response.pic[i].user_name,
                  useremail: response.pic[i].user_email,
                  userphonenumber: response.pic[i].user_phone_number,
                  userfaxnumber: response.pic[i].user_fax_number,
                };
                this.picdetails.push(obj);
              }
            }
          }
        });
    },
    makdia(flag, total, accessid) {
      this.accessid = accessid
      for (var i = 0; i < this.tabs.length; i++) {
        if (flag == this.tabs[i].name) {
          this.tabs[i].total = total
        }
      }

    },
  },
  created() {
    this.details = true;
    this.activeTab = 0;

    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    this.module = this.$route.params.module;
    this.view = this.$route.params.actionflag;
    if (this.positionid == 2) {
      console.log("sinih");
      if (this.$route.params.viewflag == "preview") {
        this.preview = true;
      } else {
        this.preview = false;
      }
    } else {
      this.preview = false;
    }
    this.getRoles();
    this.getServiceLocation();
    this.getShipType();
    this.getFlag();
    this.getFacilityType();
    this.getSW();
  },
  computed: {
    tabTitle() {
      return this.condition ? "active-tabb-title" : "inactive-tabb-title";
    },
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
    selectedLabel() {
      const selectedObj = this.selects.swes.find(option => option.value === this.selects.sw);
      return selectedObj ? selectedObj.label : 'None';
    },
  },
  watch: {
    transporterphoneno() {
      if (this.transporterphoneno.length <= 7) {
        this.istransporterphoneno = true;
      } else {
        this.istransporterphoneno = false;
      }
    },
    phonenumber() {
      if (this.phonenumber.length <= 7) {
        this.isphonenumber = true;
      } else {
        this.isphonenumber = false;
      }
    },
    companyphonenumber() {
      if (this.companyphonenumber.length <= 7) {
        this.iscompanyphonenumber = true;
      } else {
        this.iscompanyphonenumber = false;
      }
    },
    phoneno() {
      if (this.phoneno.length <= 7) {
        this.isphoneno = true;
      } else {
        this.isphoneno = false;
      }
    },
    "selects.sw"() {
      console.log(this.selects.sw);
    },
    email: debounce(function () {
      if (this.view == "add") {
        this.email_unique = "";

        let obj = {
          user_email: this.email,
        };

        this.$http
          .post(":10001/api/v1/helper/check-user-email", obj)
          .then((res) => {
            let response = res.message;

            if (!res.error) {
              this.email_unique = response;
              this.buttondisabled = false;
            } else if (res.error) {
              this.email_unique = response;
              this.buttondisabled = true;
            } else {
              this.email_unique = "";
              this.buttondisabled = false;
            }
          });

        this.email_unique = "";
      }
    }, 500),

    password() {
      if (this.password != this.confirmpassword && this.password.length < 8) {
        this.buttondisabled = true;
      }

      if (this.password == this.confirmpassword && this.password.length >= 8) {
        this.buttondisabled = false;
      }
    },

    confirmpassword() {
      if (
        this.password != this.confirmpassword &&
        this.confirmpassword.length < 8
      ) {
        this.message = "Password did not match";
        this.buttondisabled = true;
      }

      if (
        this.password == this.confirmpassword &&
        this.confirmpassword.length >= 8
      ) {
        this.message = "";
        this.buttondisabled = false;
      }
    },
    view() {
      // add
      if (this.view == "add") {
        this.fullname = "";
        this.email = "";
        this.password = "";
        this.confirmpassword = "";
        this.phoneno = "";
        this.selects.usertype = "";
        this.staffID = "";
        this.remarks = "";
        this.selects.servicelocation = "";
      }

      // edit
      if (this.view != "add") {
        this.getUserDetail(this.view, this.module);
      }
    },
    module() {
      if (this.module == "afes") {
        this.role = 1;
      }
      if (this.module == "land") {
        this.role = 2;
      }
      if (this.module == "vessel") {
        this.role = 3;
      }

      if (this.module == "vendor") {
        this.role = 4;
      }

      if (this.module == "authority") {
        this.role = 5;
      }
    },
    role() {
      this.$http.get(":10001/api/v1/setting/roles").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            if (this.role == response[i].role_id) {
              for (var j = 0; j < response[i].Position.length; j++) {
                let obj = {
                  label: response[i].Position[j].position_name,
                  value: response[i].Position[j].position_id,
                };
                this.selects.positions.push(obj);
              }
            }
          }
        }
      });
    },
    password(newValue) {
      this.checkPassword2(newValue);
    },

    picdetails: {
      handler(newpics) {
        newpics.forEach((item, index) => {
          this.checkPassword(item.password, index);
        });
      },
      deep: true,
    },
  },
};
</script>
<style>
.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

.horizontal-scroll {
  overflow-x: auto;
  /* Enables horizontal scrolling */
  white-space: nowrap;
  /* Prevents wrapping inside the row */
}

.horizontal-scroll-content {
  display: flex;
  /* Ensures content remains in a row layout */
  flex-wrap: nowrap;
  /* Prevents wrapping inside the content area */
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px;
  /* Adjust as needed */
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

.newtitle {
  color: #707070 !important;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-title {
  margin-top: -5px;
  color: #A5A5A5 !important;
}

.loading-bar {
  position: relative;
  width: 100%;
  height: 4px;
  background-color: #e0e0e0;
  margin-top: 10px;
}

.loading-bar-progress {
  position: absolute;
  height: 100%;
  background-color: #358CCB;
  transition: width 0.2s;
}

.image-container {
  position: relative;
  display: inline-block;
}

.digital-signature {
  max-width: 300px;
  max-height: 150px;
  object-fit: contain;
}

.sample-signature {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 300px;
  max-height: 150px;
  object-fit: contain;
}

.red-circle {
  color: #EC1B23;
  font-size: 12px;
}

.green-circle {
  color: #0BAA00;
  font-size: 12px;
}

.first-tabb {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  /* border-top-left-radius: 10px; */
  margin-right: 3px;
  background-color: transparent;
  box-shadow: inset;
  width: 220px;
  padding: 5px 20px;
  border-bottom: 5px solid #bbb;
}

.other-tabb {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  margin-right: 3px;
  background-color: transparent;
  box-shadow: inset;
  width: 220px;
  padding: 5px 20px;
  border-bottom: 5px solid #bbb;

  color: #358CCB;
}

.last-tabb {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  border-top-right-radius: 10px;
  margin-right: 3px;
  background-color: transparent;
  box-shadow: inset;
  width: 220px;
  padding: 5px 20px;
  border-bottom: 5px solid #bbb;

}

.inactive-tabb {
  font-size: 18px;
  font-weight: bold;
  background-color: transparent;
  border: none;
  color: #A5A5A5;
}

.active-tabb-title {
  font-size: 18px;
  font-weight: bold;
  color: #358CCB;
  text-align: center;
}

.inactive-tabb-title {
  font-size: 18px;
  font-weight: bold;
  color: #A5A5A5;
  text-align: center;
}

.tab-list {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.tab-list::-webkit-scrollbar {
  display: none;
}

.col-lg-12 {
  width: 100% !important;
}

.full-size-container {
  width: 93.25vw;
  /* height: 100vh; */
  padding: 0;
  margin: 0;
}

.table-container {
  height: calc(100vh - 200px);
  /* Adjust according to the height of other elements like header, etc. */
  overflow-y: auto;
}
</style>
